var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("drawer", {
        ref: "filterDrawer",
        scopedSlots: _vm._u([
          {
            key: "defult",
            fn: function () {
              return [
                _c(
                  "el-form-item",
                  { attrs: { label: "代理类型:" } },
                  [
                    _c(
                      "el-select",
                      {
                        on: {
                          change: function ($event) {
                            return _vm.toQuery()
                          },
                        },
                        model: {
                          value: _vm.listQuery.search_agent_level,
                          callback: function ($$v) {
                            _vm.$set(_vm.listQuery, "search_agent_level", $$v)
                          },
                          expression: "listQuery.search_agent_level",
                        },
                      },
                      _vm._l(_vm.give_role, function (itme) {
                        return _c("el-option", {
                          attrs: {
                            label: itme.role_name,
                            value: "" + itme.role_id,
                          },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    staticClass: "hidden-sm-and-down",
                    attrs: { label: "代理姓名:" },
                  },
                  [
                    _c("el-input", {
                      model: {
                        value: _vm.form.search_name,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "search_name", $$v)
                        },
                        expression: "form.search_name",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    staticClass: "hidden-xg-and-up",
                    attrs: { label: "手机号码:" },
                  },
                  [
                    _c("el-input", {
                      model: {
                        value: _vm.form.search_phone,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "search_phone", $$v)
                        },
                        expression: "form.search_phone",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "投放场地:" } },
                  [
                    _c(
                      "el-select",
                      {
                        on: {
                          change: function ($event) {
                            return _vm.toQuery()
                          },
                        },
                        model: {
                          value: _vm.listQuery.put_place,
                          callback: function ($$v) {
                            _vm.$set(_vm.listQuery, "put_place", $$v)
                          },
                          expression: "listQuery.put_place",
                        },
                      },
                      [
                        _c("el-option", {
                          attrs: { label: "请选择", value: 0 },
                        }),
                        _vm._v(" "),
                        _vm._l(_vm.put_place, function (itme) {
                          return _c("el-option", {
                            attrs: { label: itme.name, value: "" + itme.name },
                          })
                        }),
                      ],
                      2
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "排序类型:" } },
                  [
                    _c(
                      "el-select",
                      {
                        on: {
                          change: function ($event) {
                            return _vm.toQuery()
                          },
                        },
                        model: {
                          value: _vm.listQuery.sort_type,
                          callback: function ($$v) {
                            _vm.$set(_vm.listQuery, "sort_type", $$v)
                          },
                          expression: "listQuery.sort_type",
                        },
                      },
                      _vm._l(_vm.sort_type, function (itme) {
                        return _c("el-option", {
                          attrs: { label: itme.name, value: "" + itme.value },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    staticClass: "hidden-lg-and-down",
                    attrs: { label: "手机号码:" },
                  },
                  [
                    _c("el-input", {
                      model: {
                        value: _vm.form.search_phone,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "search_phone", $$v)
                        },
                        expression: "form.search_phone",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    staticClass: "hidden-xg-and-down",
                    attrs: { label: "代理状态:" },
                  },
                  [
                    _c(
                      "el-select",
                      {
                        on: {
                          change: function ($event) {
                            return _vm.toQuery()
                          },
                        },
                        model: {
                          value: _vm.listQuery.activated_status,
                          callback: function ($$v) {
                            _vm.$set(_vm.listQuery, "activated_status", $$v)
                          },
                          expression: "listQuery.activated_status",
                        },
                      },
                      [
                        _c("el-option", { attrs: { label: "有效", value: 1 } }),
                        _vm._v(" "),
                        _c("el-option", { attrs: { label: "无效", value: 2 } }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "是否冻结:" } },
                  [
                    _c(
                      "el-select",
                      {
                        on: {
                          change: function ($event) {
                            return _vm.toQuery()
                          },
                        },
                        model: {
                          value: _vm.listQuery.is_frozen,
                          callback: function ($$v) {
                            _vm.$set(_vm.listQuery, "is_frozen", $$v)
                          },
                          expression: "listQuery.is_frozen",
                        },
                      },
                      [
                        _c("el-option", {
                          attrs: { label: "全部", value: "-1" },
                        }),
                        _vm._v(" "),
                        _c("el-option", {
                          attrs: { label: "未冻结", value: "0" },
                        }),
                        _vm._v(" "),
                        _c("el-option", {
                          attrs: { label: "已冻结", value: "1" },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-button",
                      { attrs: { type: "primary", "native-type": "submit" } },
                      [
                        _vm._v("查询"),
                        _c("i", {
                          staticClass: "el-icon-search el-icon--right",
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "warning", plain: "" },
                        on: {
                          click: function ($event) {
                            return _vm.toQuery(1)
                          },
                        },
                      },
                      [
                        _vm._v("重置"),
                        _c("i", {
                          staticClass: "el-icon-refresh el-icon--right",
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", plain: "" },
                        on: {
                          click: function ($event) {
                            return _vm.outTab("list_table", "代理记录")
                          },
                        },
                      },
                      [
                        _vm._v("导出"),
                        _c("i", { staticClass: "el-icon-male el-icon--right" }),
                      ]
                    ),
                    _vm._v(" "),
                    String(_vm.listQuery.is_frozen) === "1"
                      ? _c(
                          "span",
                          {
                            staticStyle: {
                              "margin-left": "10px",
                              "font-weight": "bold",
                              color: "#f56c6c",
                              display: "inline-block",
                            },
                          },
                          [
                            _vm._v(
                              "已冻结代理可提金额合计：￥" +
                                _vm._s(_vm.frozenAvailableTotal)
                            ),
                          ]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "more",
            fn: function () {
              return [
                _vm.checkRoles(["terminal"])
                  ? _c("sel-plat", {
                      attrs: { listQuery: _vm.listQuery },
                      on: {
                        change: function ($event) {
                          return _vm.toQuery()
                        },
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    staticClass: "hidden-md-and-up",
                    attrs: { label: "姓名:" },
                  },
                  [
                    _c("el-input", {
                      model: {
                        value: _vm.form.search_name,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "search_name", $$v)
                        },
                        expression: "form.search_name",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("el-form-item", { attrs: { label: "创建时间:" } }, [
                  _c(
                    "div",
                    { staticClass: "flex" },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          type: "datetime",
                          placeholder: "开始日期",
                          "value-format": "timestamp",
                          "picker-options": _vm.beginOptions,
                        },
                        model: {
                          value: _vm.form.begin,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "begin", $$v)
                          },
                          expression: "form.begin",
                        },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "ml-5 mr-5" }, [_vm._v("-")]),
                      _vm._v(" "),
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          type: "datetime",
                          placeholder: "结束日期",
                          "value-format": "timestamp",
                          "picker-options": _vm.endOptions,
                        },
                        model: {
                          value: _vm.form.end,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "end", $$v)
                          },
                          expression: "form.end",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "设备类型:" } },
                  [
                    _c(
                      "el-select",
                      {
                        on: {
                          change: function ($event) {
                            return _vm.toQuery()
                          },
                        },
                        model: {
                          value: _vm.form.search_device_factory_id,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "search_device_factory_id", $$v)
                          },
                          expression: "form.search_device_factory_id",
                        },
                      },
                      [
                        _c("el-option", {
                          attrs: { label: "桌面充电宝", value: "SWITCH123456" },
                        }),
                        _vm._v(" "),
                        _c("el-option", {
                          attrs: {
                            label: "蓝牙开关插座",
                            value: "SWITCH112901",
                          },
                        }),
                        _vm._v(" "),
                        _c("el-option", {
                          attrs: { label: "10路桩", value: "DianLaLa104G" },
                        }),
                        _vm._v(" "),
                        _c("el-option", {
                          attrs: { label: "16路桩", value: "DianLaLa16TCP4G" },
                        }),
                        _vm._v(" "),
                        _c("el-option", {
                          attrs: { label: "2路4G", value: "DianLaLa4G" },
                        }),
                        _vm._v(" "),
                        _c("el-option", {
                          attrs: { label: "2路蓝牙", value: "DianLaLaBLE" },
                        }),
                        _vm._v(" "),
                        _c("el-option", {
                          attrs: { label: "2路大功率", value: "DianLaLaHP4G" },
                        }),
                        _vm._v(" "),
                        _c("el-option", {
                          attrs: {
                            label: "2路刷卡2200瓦",
                            value: "DianLaLaS4G",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    staticClass: "hidden-xl-only",
                    attrs: { label: "代理状态:" },
                  },
                  [
                    _c(
                      "el-select",
                      {
                        on: {
                          change: function ($event) {
                            return _vm.toQuery()
                          },
                        },
                        model: {
                          value: _vm.listQuery.activated_status,
                          callback: function ($$v) {
                            _vm.$set(_vm.listQuery, "activated_status", $$v)
                          },
                          expression: "listQuery.activated_status",
                        },
                      },
                      [
                        _c("el-option", { attrs: { label: "有效", value: 1 } }),
                        _vm._v(" "),
                        _c("el-option", { attrs: { label: "无效", value: 2 } }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "p-5" },
        [
          String(_vm.listQuery.is_frozen) === "1"
            ? _c(
                "div",
                {
                  staticClass:
                    "bg-white padding-sm margin-bottom-sm text-center",
                  staticStyle: {
                    color: "#f56c6c",
                    "font-weight": "bold",
                    "font-size": "16px",
                  },
                },
                [
                  _vm._v(
                    "\n        已冻结代理可提金额合计：￥" +
                      _vm._s(_vm.frozenAvailableTotal) +
                      "\n      "
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "bg-white" },
            [
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.listLoading,
                      expression: "listLoading",
                    },
                  ],
                  ref: "list_table",
                  staticClass: "ptd-5",
                  attrs: {
                    id: "list_table",
                    data: _vm.list,
                    "element-loading-text": "Loading",
                    stripe: "",
                    "highlight-current-row": "",
                    "max-height": _vm.tableMaxH,
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: { label: "代理信息", width: "220" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-link",
                              {
                                staticClass: "fs-c1",
                                attrs: {
                                  href:
                                    "/userManage/user_order?son_id=" +
                                    scope.row.aid,
                                  target: "_blank",
                                  type: "primary",
                                },
                              },
                              [
                                _c("div", [
                                  _vm._v(
                                    _vm._s(scope.row.name) +
                                      "(" +
                                      _vm._s(scope.row.agent_name) +
                                      _vm._s(scope.row.aid) +
                                      ")"
                                  ),
                                ]),
                                _vm._v(" "),
                                _vm.checkHidRole("agentPclbsjhxs")
                                  ? _c("div", [
                                      _vm._v(
                                        "账户：" + _vm._s(scope.row.phone)
                                      ),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("div", [
                                  _vm._v(
                                    "登录：" +
                                      _vm._s(
                                        _vm.parseTime(
                                          scope.row.login_time,
                                          "{y}-{m}-{d} {h}:{i}"
                                        )
                                      )
                                  ),
                                ]),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "用户", width: "130" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "div",
                              { staticClass: "flex align-center" },
                              [
                                _c("el-avatar", {
                                  attrs: {
                                    size: "small",
                                    src: scope.row.avatar,
                                  },
                                }),
                                _vm._v(" "),
                                _c("div", { staticClass: "flex1 ml-5" }, [
                                  _vm._v(_vm._s(scope.row.nick_name)),
                                  scope.row.is_frozen == 1
                                    ? _c(
                                        "span",
                                        { staticClass: "frozen-badge" },
                                        [_vm._v("⚠异")]
                                      )
                                    : _vm._e(),
                                ]),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _vm.checkRoles("terminal")
                    ? _c("el-table-column", {
                        attrs: { label: "设备与收益", width: "120" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "text-blue cursor",
                                      on: {
                                        click: function ($event) {
                                          return _vm.toEdit({
                                            id: scope.row.id,
                                            type: 13,
                                          })
                                        },
                                      },
                                    },
                                    [_vm._v("查看")]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          4289387635
                        ),
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.checkRoles(["terminal"])
                    ? _c("el-table-column", {
                        attrs: { label: "设备", width: "150" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return _vm._l(
                                  scope.row.device_info,
                                  function (item, index) {
                                    return _c(
                                      "div",
                                      {
                                        staticClass: "cursor",
                                        on: {
                                          click: function ($event) {
                                            return _vm.$router.push({
                                              path:
                                                "/equipment/subEquipment?son_id=" +
                                                scope.row.id,
                                            })
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(_vm.deviceKeyObj[index]) +
                                            "："
                                        ),
                                        _c(
                                          "span",
                                          { staticClass: "text-blue" },
                                          [_vm._v(_vm._s(item))]
                                        ),
                                      ]
                                    )
                                  }
                                )
                              },
                            },
                          ],
                          null,
                          false,
                          3715669622
                        ),
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.checkRoles(["terminal"])
                    ? _c("el-table-column", {
                        attrs: { label: "设备类型", width: "120" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return _vm._l(
                                  scope.row.device_info_d,
                                  function (item, index) {
                                    return _c("div", [
                                      item > 0
                                        ? _c("span", [
                                            _vm._v(_vm._s(index) + "："),
                                            _c(
                                              "span",
                                              { staticClass: "text-blue" },
                                              [_vm._v(_vm._s(item))]
                                            ),
                                          ])
                                        : _vm._e(),
                                    ])
                                  }
                                )
                              },
                            },
                          ],
                          null,
                          false,
                          1550161517
                        ),
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "下级总数" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-link",
                              {
                                staticClass: "fs-c1",
                                attrs: {
                                  href:
                                    "/userManage/user_order?son_id=" +
                                    scope.row.aid,
                                  target: "_blank",
                                  type: "primary",
                                },
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(scope.row.child_agent_num) +
                                    "\n              "
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _vm.checkHidRole("agentPclbjexs") &&
                  !_vm.checkRoles(["terminal"])
                    ? _c("el-table-column", {
                        attrs: { width: "140", label: "可提现金额" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _vm.checkRoles(["partner"]) &&
                                  _vm.checkHidRole("agent_ktxje")
                                    ? _c(
                                        "a",
                                        {
                                          staticClass: "text-blue cursor",
                                          on: {
                                            click: function ($event) {
                                              return _vm.$refs.editwith.showDialog(
                                                scope.row
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("￥" + _vm._s(scope.row.money))]
                                      )
                                    : _c("a", [
                                        _vm._v("￥" + _vm._s(scope.row.money)),
                                      ]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          265892816
                        ),
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.checkHidRole("agentPclbjexs") &&
                  !_vm.checkRoles(["terminal"])
                    ? _c("el-table-column", {
                        attrs: { width: "140", label: "收益金额" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "cursor",
                                      on: {
                                        click: function ($event) {
                                          return _vm.$router.push({
                                            path:
                                              "/home/income?son_id=" +
                                              scope.row.id,
                                          })
                                        },
                                      },
                                    },
                                    [
                                      _c("span", { staticClass: "text-blue" }, [
                                        _vm._v(
                                          _vm._s(scope.row.income || "0.00") +
                                            "元"
                                        ),
                                      ]),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3824013271
                        ),
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.checkHidRole("agentPclbjexs") &&
                  !_vm.checkRoles(["terminal"])
                    ? _c("el-table-column", {
                        attrs: { width: "140", label: "近七天收益" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "cursor",
                                      on: {
                                        click: function ($event) {
                                          return _vm.$router.push({
                                            path:
                                              "/home/income?son_id=" +
                                              scope.row.id,
                                          })
                                        },
                                      },
                                    },
                                    [
                                      _c("span", { staticClass: "text-blue" }, [
                                        _vm._v(
                                          _vm._s(
                                            scope.row.seven_profit || "0.00"
                                          ) + "元"
                                        ),
                                      ]),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3159455318
                        ),
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.checkHidRole("agentPclbjexs") &&
                  !_vm.checkRoles(["terminal"])
                    ? _c("el-table-column", {
                        attrs: { width: "140", label: "冻结金额" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "cursor",
                                      on: {
                                        click: function ($event) {
                                          return _vm.toEdit({
                                            id: scope.row.id,
                                            type: 2,
                                          })
                                        },
                                      },
                                    },
                                    [
                                      _c("span", { staticClass: "text-blue" }, [
                                        _vm._v(
                                          _vm._s(scope.row.freez_money) + "元"
                                        ),
                                      ]),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1449214755
                        ),
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.checkHidRole("agentPclbjexs")
                    ? _c("el-table-column", {
                        attrs: { width: "200", label: "分润比例" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return _vm._l(
                                  scope.row.percent_info,
                                  function (item, index) {
                                    return _c("div", [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(_vm.deviceKeyObj[index]) +
                                          "：" +
                                          _vm._s(
                                            item[
                                              _vm.config.goods_key[index] +
                                                "_percent"
                                            ]
                                          ) +
                                          "%\n              "
                                      ),
                                    ])
                                  }
                                )
                              },
                            },
                          ],
                          null,
                          false,
                          3753519888
                        ),
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.checkRoles(["partner"])
                    ? _c("el-table-column", {
                        attrs: { label: "投放天数" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.todays(scope.row.add_date)) +
                                      "天\n            "
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1921462219
                        ),
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "投放场地" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              "\n              " +
                                _vm._s(scope.row.put_place || "无") +
                                "\n            "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "开户时间", width: "120" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.parseTime(
                                    scope.row.add_date,
                                    "{y}-{m}-{d}"
                                  )
                                ) +
                                "\n            "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _vm.getToken("agent_id") == 173
                    ? _c("el-table-column", {
                        attrs: { label: "盈利金额", width: "129" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  scope.row.break_even_profit
                                    ? _c("span", [
                                        _vm._v(
                                          "￥" +
                                            _vm._s(scope.row.break_even_profit)
                                        ),
                                      ])
                                    : _vm._e(),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3476892055
                        ),
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.getToken("agent_id") == 173
                    ? _c("el-table-column", {
                        attrs: { label: "已收金额", width: "129" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  scope.row.total_change_money
                                    ? _c("span", [
                                        _vm._v(
                                          "￥" +
                                            _vm._s(scope.row.total_change_money)
                                        ),
                                      ])
                                    : _vm._e(),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3966201815
                        ),
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.getToken("agent_id") == 173
                    ? _c("el-table-column", {
                        attrs: { label: "回本倒计时", width: "129" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  scope.row.days_since_operation
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(scope.row.days_since_operation)
                                        ),
                                      ])
                                    : _vm._e(),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1873227033
                        ),
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.checkRoles(["terminal"]) && _vm.user_type == 0
                    ? _c("el-table-column", {
                        attrs: { label: "贴牌操作", width: "190" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _vm.checkRoles(["terminal"])
                                    ? _c(
                                        "el-button",
                                        {
                                          staticClass: "ml-0",
                                          attrs: {
                                            type: "primary",
                                            size: "mini",
                                            round: "",
                                            plain: "",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.$router.push({
                                                path:
                                                  "/qrcode/index?son_id=" +
                                                  scope.row.id,
                                              })
                                            },
                                          },
                                        },
                                        [_vm._v("分配设备")]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "el-button",
                                    {
                                      staticClass: "ml-0",
                                      attrs: {
                                        type: "primary",
                                        size: "mini",
                                        round: "",
                                        plain: "",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.$router.push({
                                            path:
                                              "/station/oemMoney?id=" +
                                              scope.row.id,
                                          })
                                        },
                                      },
                                    },
                                    [_vm._v("续费金额")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-button",
                                    {
                                      staticClass: "ml-0",
                                      attrs: {
                                        type: "primary",
                                        size: "mini",
                                        round: "",
                                        plain: "",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.getMapIcon(scope.row)
                                        },
                                      },
                                    },
                                    [_vm._v("地图图标")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-button",
                                    {
                                      staticClass: "ml-0",
                                      attrs: {
                                        type: "primary",
                                        size: "mini",
                                        round: "",
                                        plain: "",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.copyloginUrl(scope.row)
                                        },
                                      },
                                    },
                                    [_vm._v("登录地址")]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3891612690
                        ),
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "操作", width: "270", fixed: "right" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm.zuo_sn
                              ? [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        type: "primary",
                                        size: "mini",
                                        round: "",
                                        plain: "",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.setEquip(scope.row)
                                        },
                                      },
                                    },
                                    [_vm._v("分配给TA")]
                                  ),
                                ]
                              : [
                                  !_vm.checkRoles(["terminal"]) &&
                                  _vm.checkHidRole("agentPcfpsb")
                                    ? _c(
                                        "el-button",
                                        {
                                          staticClass: "ml-0",
                                          attrs: {
                                            type: "primary",
                                            size: "mini",
                                            round: "",
                                            plain: "",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.$router.push({
                                                path:
                                                  "/equipment/index?agent_id=" +
                                                  scope.row.id,
                                              })
                                            },
                                          },
                                        },
                                        [_vm._v("分配设备")]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.checkHidRole("agentPcfpjl")
                                    ? _c(
                                        "el-button",
                                        {
                                          staticClass: "ml-0",
                                          attrs: {
                                            type: "primary",
                                            size: "mini",
                                            round: "",
                                            plain: "",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.$router.push({
                                                path:
                                                  "/agent/equip?type=2&son_id=" +
                                                  scope.row.id,
                                              })
                                            },
                                          },
                                        },
                                        [_vm._v("分配记录")]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.checkHidRole("agentPcshlb")
                                    ? _c(
                                        "el-button",
                                        {
                                          staticClass: "ml-0",
                                          attrs: {
                                            type: "primary",
                                            size: "mini",
                                            round: "",
                                            plain: "",
                                          },
                                        },
                                        [
                                          _c(
                                            "a",
                                            {
                                              attrs: {
                                                href:
                                                  "/shop/subShop?son_id=" +
                                                  scope.row.id,
                                                target: "_blank",
                                              },
                                            },
                                            [_vm._v("商户列表")]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.agentInfo.check_order == 1 &&
                                  _vm.checkHidRole("agentPcddlb")
                                    ? _c(
                                        "el-button",
                                        {
                                          staticClass: "ml-0",
                                          attrs: {
                                            type: "primary",
                                            size: "mini",
                                            round: "",
                                            plain: "",
                                          },
                                        },
                                        [
                                          _c(
                                            "a",
                                            {
                                              attrs: {
                                                href:
                                                  "/order/morder?son_id=" +
                                                  scope.row.id,
                                                target: "_blank",
                                              },
                                            },
                                            [_vm._v("订单列表")]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.checkHidRole("agentPcxgxx")
                                    ? _c(
                                        "el-button",
                                        {
                                          staticClass: "ml-0",
                                          attrs: {
                                            type: "primary",
                                            size: "mini",
                                            round: "",
                                            plain: "",
                                          },
                                        },
                                        [
                                          _c(
                                            "a",
                                            {
                                              attrs: {
                                                href:
                                                  "/agent/edit/" + scope.row.id,
                                                target: "_blank",
                                              },
                                            },
                                            [_vm._v("修改信息")]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.checkHidRole("agentPcdlmm")
                                    ? _c(
                                        "el-button",
                                        {
                                          staticClass: "ml-0",
                                          attrs: {
                                            type: "primary",
                                            size: "mini",
                                            round: "",
                                            plain: "",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.toEdit({
                                                id: scope.row.id,
                                                type: 5,
                                              })
                                            },
                                          },
                                        },
                                        [_vm._v("登录密码")]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  (_vm.agentInfo.steal_order_right == 1 ||
                                    scope.row.steal_order_switch == 1) &&
                                  !_vm.checkRoles(["terminal"]) &&
                                  _vm.checkHidRole("agentPcddgb")
                                    ? _c(
                                        "el-button",
                                        {
                                          staticClass: "ml-0",
                                          attrs: {
                                            type: "primary",
                                            size: "mini",
                                            round: "",
                                            plain: "",
                                          },
                                        },
                                        [
                                          _c(
                                            "a",
                                            {
                                              attrs: {
                                                href:
                                                  "/shop/steal/" +
                                                  scope.row.id +
                                                  "?type=2",
                                                target: "_blank",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    scope.row
                                                      .steal_order_right == 1 ||
                                                      scope.row
                                                        .steal_order_switch == 1
                                                      ? "掉单开启"
                                                      : "掉单关闭"
                                                  )
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.checkHidRole("agentPcmfdy")
                                    ? _c(
                                        "el-button",
                                        {
                                          staticClass: "ml-0",
                                          attrs: {
                                            type: "primary",
                                            size: "mini",
                                            round: "",
                                            plain: "",
                                          },
                                          on: {
                                            click: function ($event) {
                                              _vm.freeDialog = true
                                              _vm.freeObj = scope.row
                                            },
                                          },
                                        },
                                        [_vm._v("免费店员")]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "el-dropdown",
                                    { attrs: { trigger: "click" } },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            type: "primary",
                                            size: "mini",
                                            round: "",
                                            plain: "",
                                          },
                                        },
                                        [_vm._v("更多设置")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-dropdown-menu",
                                        {
                                          attrs: { slot: "dropdown" },
                                          slot: "dropdown",
                                        },
                                        [
                                          _vm.checkHidRole("agentPcggqx")
                                            ? _c(
                                                "el-dropdown-item",
                                                {
                                                  nativeOn: {
                                                    click: function ($event) {
                                                      return _vm.$router.push({
                                                        path:
                                                          "/adver/position?son_id=" +
                                                          scope.row.id,
                                                      })
                                                    },
                                                  },
                                                },
                                                [_vm._v("广告权限")]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.checkHidRole("agentPctxfl")
                                            ? _c(
                                                "el-dropdown-item",
                                                {
                                                  nativeOn: {
                                                    click: function ($event) {
                                                      return _vm.toEdit({
                                                        id: scope.row.id,
                                                        type: 3,
                                                      })
                                                    },
                                                  },
                                                },
                                                [_vm._v("提现费率")]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.checkHidRole("agentPctxmm")
                                            ? _c(
                                                "el-dropdown-item",
                                                {
                                                  nativeOn: {
                                                    click: function ($event) {
                                                      return _vm.toEdit({
                                                        id: scope.row.id,
                                                        type: 7,
                                                      })
                                                    },
                                                  },
                                                },
                                                [_vm._v("提现密码")]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.checkHidRole("agentPchtgl")
                                            ? _c(
                                                "el-dropdown-item",
                                                {
                                                  nativeOn: {
                                                    click: function ($event) {
                                                      return _vm.$router.push({
                                                        path:
                                                          "/agent/contract?son_id=" +
                                                          scope.row.id +
                                                          "&level=" +
                                                          scope.row.agent_level,
                                                      })
                                                    },
                                                  },
                                                },
                                                [_vm._v("合同管理")]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.checkRoles(["terminal"])
                                            ? _c(
                                                "el-dropdown-item",
                                                {
                                                  nativeOn: {
                                                    click: function ($event) {
                                                      return _vm.toLogin(
                                                        scope.row
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("登录后台")]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.listQuery.activated_status == 1 &&
                                          _vm.checkHidRole("agentPcscdl")
                                            ? _c(
                                                "el-dropdown-item",
                                                {
                                                  nativeOn: {
                                                    click: function ($event) {
                                                      return _vm.toEdit({
                                                        id: scope.row.id,
                                                        type: 4,
                                                        index: scope.$index,
                                                      })
                                                    },
                                                  },
                                                },
                                                [_vm._v("删除代理")]
                                              )
                                            : _vm.listQuery.activated_status !=
                                                1 &&
                                              !_vm.checkHidRole("agentPcscdl")
                                            ? _c(
                                                "el-dropdown-item",
                                                {
                                                  nativeOn: {
                                                    click: function ($event) {
                                                      return _vm.toEdit({
                                                        id: scope.row.id,
                                                        type: 8,
                                                        index: scope.$index,
                                                      })
                                                    },
                                                  },
                                                },
                                                [_vm._v("恢复显示")]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.checkRoles(["terminal"]) &&
                                          _vm.user_type == 0
                                            ? _c(
                                                "el-dropdown-item",
                                                {
                                                  nativeOn: {
                                                    click: function ($event) {
                                                      return _vm.$router.push({
                                                        path:
                                                          "/qrcode/create?aid=" +
                                                          scope.row.id,
                                                      })
                                                    },
                                                  },
                                                },
                                                [_vm._v("二维码生成")]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          scope.row.role_id == 2 &&
                                          _vm.checkRoles(["partner"]) &&
                                          _vm.checkHidRole("agentPcjfytx")
                                            ? _c(
                                                "el-dropdown-item",
                                                {
                                                  nativeOn: {
                                                    click: function ($event) {
                                                      return _vm.$router.push({
                                                        path:
                                                          "/agent/agentBilling?son_id=" +
                                                          scope.row.id,
                                                      })
                                                    },
                                                  },
                                                },
                                                [_vm._v("计费与提现")]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.checkRoles(["partner"]) &&
                                          _vm.checkHidRole("agentPctxsxfsz")
                                            ? _c(
                                                "el-dropdown-item",
                                                {
                                                  nativeOn: {
                                                    click: function ($event) {
                                                      return _vm.toEdit({
                                                        id: scope.row.id,
                                                        type: 9,
                                                      })
                                                    },
                                                  },
                                                },
                                                [_vm._v("提现手续费设置")]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.checkRoles(["partner"]) &&
                                          _vm.checkHidRole("agentPcyjfcsz")
                                            ? _c(
                                                "el-dropdown-item",
                                                {
                                                  nativeOn: {
                                                    click: function ($event) {
                                                      return _vm.toEdit({
                                                        id: scope.row.id,
                                                        type: 10,
                                                      })
                                                    },
                                                  },
                                                },
                                                [_vm._v("平台补贴设置")]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.checkHidRole("agentPccgj")
                                            ? _c(
                                                "el-dropdown-item",
                                                {
                                                  nativeOn: {
                                                    click: function ($event) {
                                                      return _vm.$router.push({
                                                        path:
                                                          "/agent/buyprice?son_id=" +
                                                          scope.row.id,
                                                      })
                                                    },
                                                  },
                                                },
                                                [_vm._v("采购价")]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.checkRoles(["partner"]) &&
                                          _vm.checkHidRole("agentSbhs")
                                            ? _c(
                                                "el-dropdown-item",
                                                {
                                                  nativeOn: {
                                                    click: function ($event) {
                                                      return _vm.$router.push({
                                                        path:
                                                          "/equipment/subEquipment?son_id=" +
                                                          scope.row.id,
                                                      })
                                                    },
                                                  },
                                                },
                                                [_vm._v("设备回收")]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.checkRoles(["partner"]) &&
                                          _vm.checkHidRole("agentPczhsz")
                                            ? _c(
                                                "el-dropdown-item",
                                                {
                                                  nativeOn: {
                                                    click: function ($event) {
                                                      return _vm.toEdit({
                                                        id: scope.row.id,
                                                        type: 11,
                                                      })
                                                    },
                                                  },
                                                },
                                                [_vm._v("账号设置")]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.checkRoles(["terminal"])
                                            ? _c(
                                                "el-dropdown-item",
                                                {
                                                  nativeOn: {
                                                    click: function ($event) {
                                                      return _vm.openTerminalAccountSetting(
                                                        scope.row
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("账号设置")]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.checkRoles(["partner"]) &&
                                          _vm.checkHidRole("agentYezz")
                                            ? _c(
                                                "el-dropdown-item",
                                                {
                                                  nativeOn: {
                                                    click: function ($event) {
                                                      return _vm.toEdit({
                                                        id: scope.row.id,
                                                        type: 12,
                                                      })
                                                    },
                                                  },
                                                },
                                                [_vm._v("余额增值")]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.checkRoles(["partner"])
                                            ? _c(
                                                "el-dropdown-item",
                                                {
                                                  nativeOn: {
                                                    click: function ($event) {
                                                      return _vm.toEdit({
                                                        id: scope.row.id,
                                                        type: 14,
                                                      })
                                                    },
                                                  },
                                                },
                                                [_vm._v("添加推荐官")]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c(
                                            "el-dropdown-item",
                                            {
                                              nativeOn: {
                                                click: function ($event) {
                                                  return _vm.toEdit({
                                                    id: scope.row.id,
                                                    aid: scope.row.aid,
                                                    name: scope.row.name,
                                                    type: 15,
                                                  })
                                                },
                                              },
                                            },
                                            [_vm._v("商户电费授权")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "flex justify-center" },
                [
                  _c("pagination", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.listQuery.page_num > 0,
                        expression: "listQuery.page_num > 0",
                      },
                    ],
                    attrs: {
                      page: _vm.listQuery.start,
                      limit: _vm.listQuery.limit,
                      "page-count": _vm.listQuery.page_num,
                    },
                    on: {
                      "update:page": function ($event) {
                        return _vm.$set(_vm.listQuery, "start", $event)
                      },
                      "update:limit": function ($event) {
                        return _vm.$set(_vm.listQuery, "limit", $event)
                      },
                      pagination: _vm.getList,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-dialog",
            {
              attrs: { title: "提现费率", visible: _vm.withdrawDialog },
              on: {
                "update:visible": function ($event) {
                  _vm.withdrawDialog = $event
                },
              },
            },
            [
              _c("el-form", [
                _c(
                  "div",
                  { staticClass: "mb-10 flex align-center" },
                  [
                    _c(
                      "el-checkbox",
                      {
                        attrs: { "true-label": 0, disabled: "" },
                        model: {
                          value: _vm.siteInfo.agent_withdraw_fee_type,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.siteInfo,
                              "agent_withdraw_fee_type",
                              $$v
                            )
                          },
                          expression: "siteInfo.agent_withdraw_fee_type",
                        },
                      },
                      [_vm._v("按比例：")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-input",
                      {
                        staticClass: "flex1",
                        attrs: {
                          oninput: "value=value.replace(/[^\\d.]/g,'')",
                        },
                        model: {
                          value: _vm.withdrawObj.withdraw_percent,
                          callback: function ($$v) {
                            _vm.$set(_vm.withdrawObj, "withdraw_percent", $$v)
                          },
                          expression: "withdrawObj.withdraw_percent",
                        },
                      },
                      [_c("template", { slot: "append" }, [_vm._v("%")])],
                      2
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "mb-10 flex align-center" },
                  [
                    _c(
                      "el-checkbox",
                      {
                        attrs: { "true-label": 1, disabled: "" },
                        model: {
                          value: _vm.siteInfo.agent_withdraw_fee_type,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.siteInfo,
                              "agent_withdraw_fee_type",
                              $$v
                            )
                          },
                          expression: "siteInfo.agent_withdraw_fee_type",
                        },
                      },
                      [_vm._v("按单笔：")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-input",
                      {
                        staticClass: "flex1",
                        attrs: {
                          oninput: "value=value.replace(/[^\\d.]/g,'')",
                        },
                        model: {
                          value: _vm.withdrawObj.withdraw_fee,
                          callback: function ($$v) {
                            _vm.$set(_vm.withdrawObj, "withdraw_fee", $$v)
                          },
                          expression: "withdrawObj.withdraw_fee",
                        },
                      },
                      [_c("template", { slot: "append" }, [_vm._v("元")])],
                      2
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "fs-s2 text-gray" }, [
                  _vm._v(
                    "注：您填写增加的手续费，将在下级代理提现时以分润的方式发放到您的账户，下级代理提现手续费 = 您设置的手续费 + 总后台设置的手续费。"
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.withdrawDialog = false
                        },
                      },
                    },
                    [_vm._v("取 消")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.setWithdraw()
                        },
                      },
                    },
                    [_vm._v("确 定")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-dialog",
            {
              attrs: {
                title: "提现手续费设置",
                visible: _vm.withdrawFeeDialog,
              },
              on: {
                "update:visible": function ($event) {
                  _vm.withdrawFeeDialog = $event
                },
              },
            },
            [
              _c(
                "el-form",
                { attrs: { "label-width": "150px" } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "收取方式：" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.withdrawFeeObj.config_mode,
                            callback: function ($$v) {
                              _vm.$set(_vm.withdrawFeeObj, "config_mode", $$v)
                            },
                            expression: "withdrawFeeObj.config_mode",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: 0 } }, [
                            _vm._v("跟随原配置"),
                          ]),
                          _vm._v(" "),
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v("单独比例"),
                          ]),
                          _vm._v(" "),
                          _c("el-radio", { attrs: { label: 2 } }, [
                            _vm._v("单独金额"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.withdrawFeeObj.config_mode == 1
                    ? [
                        _c(
                          "el-form-item",
                          { attrs: { label: "提现手续费比例：" } },
                          [
                            _c(
                              "el-input",
                              {
                                staticClass: "flex1",
                                attrs: {
                                  oninput: "value=value.replace(/[^\\d.]/g,'')",
                                },
                                model: {
                                  value: _vm.withdrawFeeObj.withdraw_rate,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.withdrawFeeObj,
                                      "withdraw_rate",
                                      $$v
                                    )
                                  },
                                  expression: "withdrawFeeObj.withdraw_rate",
                                },
                              },
                              [
                                _c("template", { slot: "append" }, [
                                  _vm._v("%"),
                                ]),
                              ],
                              2
                            ),
                          ],
                          1
                        ),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.withdrawFeeObj.config_mode == 2
                    ? [
                        _c(
                          "el-form-item",
                          { attrs: { label: "提现手续费金额：" } },
                          [
                            _c(
                              "el-input",
                              {
                                staticClass: "flex1",
                                attrs: {
                                  oninput: "value=value.replace(/[^\\d.]/g,'')",
                                },
                                model: {
                                  value: _vm.withdrawFeeObj.withdraw_amount,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.withdrawFeeObj,
                                      "withdraw_amount",
                                      $$v
                                    )
                                  },
                                  expression: "withdrawFeeObj.withdraw_amount",
                                },
                              },
                              [
                                _c("template", { slot: "append" }, [
                                  _vm._v("元"),
                                ]),
                              ],
                              2
                            ),
                          ],
                          1
                        ),
                      ]
                    : _vm._e(),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.withdrawFeeDialog = false
                        },
                      },
                    },
                    [_vm._v("取 消")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.setWithdrawFee()
                        },
                      },
                    },
                    [_vm._v("确 定")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-dialog",
            {
              attrs: { title: "平台补贴设置", visible: _vm.banlanceSetDialog },
              on: {
                "update:visible": function ($event) {
                  _vm.banlanceSetDialog = $event
                },
              },
            },
            [
              _c(
                "el-form",
                { attrs: { "label-width": "150px" } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "是否开启平台补贴：" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.balanceSetObj.is_deposit_sharing,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.balanceSetObj,
                                "is_deposit_sharing",
                                $$v
                              )
                            },
                            expression: "balanceSetObj.is_deposit_sharing",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: 0 } }, [
                            _vm._v("否"),
                          ]),
                          _vm._v(" "),
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v("是"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "代理平台补贴比例：" } },
                      [
                        _c(
                          "el-input",
                          {
                            staticClass: "flex1",
                            attrs: {
                              oninput:
                                "value=value>100 ? 100 : value.replace(/[^0-9]/g, '')",
                            },
                            model: {
                              value: _vm.balanceSetObj.agent_sharing_ratio,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.balanceSetObj,
                                  "agent_sharing_ratio",
                                  $$v
                                )
                              },
                              expression: "balanceSetObj.agent_sharing_ratio",
                            },
                          },
                          [_c("template", { slot: "append" }, [_vm._v("%")])],
                          2
                        ),
                      ],
                      1
                    ),
                  ],
                  _vm._v(" "),
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "商户平台补贴比例：" } },
                      [
                        _c(
                          "el-input",
                          {
                            staticClass: "flex1",
                            attrs: {
                              oninput:
                                "value=value>100 ? 100 : value.replace(/[^0-9]/g, '')",
                            },
                            model: {
                              value:
                                _vm.balanceSetObj.store_deposit_sharing_ratio,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.balanceSetObj,
                                  "store_deposit_sharing_ratio",
                                  $$v
                                )
                              },
                              expression:
                                "balanceSetObj.store_deposit_sharing_ratio",
                            },
                          },
                          [_c("template", { slot: "append" }, [_vm._v("%")])],
                          2
                        ),
                      ],
                      1
                    ),
                  ],
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.banlanceSetDialog = false
                        },
                      },
                    },
                    [_vm._v("取 消")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.setAgentBalance()
                        },
                      },
                    },
                    [_vm._v("确 定")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-dialog",
            {
              attrs: {
                title: "商户电费授权",
                visible: _vm.merchantElectricityAuthDialog,
                width: "480px",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.merchantElectricityAuthDialog = $event
                },
              },
            },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.merchantElectricityAuthLoading,
                      expression: "merchantElectricityAuthLoading",
                    },
                  ],
                },
                [
                  _c(
                    "el-form",
                    { attrs: { "label-width": "120px" } },
                    [
                      _c("el-form-item", { attrs: { label: "代理：" } }, [
                        _c("span", { staticClass: "text-bold" }, [
                          _vm._v(
                            _vm._s(_vm.merchantElectricityAuthObj.name || "—")
                          ),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "text-gray ml-5" }, [
                          _vm._v(
                            "AID: " + _vm._s(_vm.merchantElectricityAuthObj.aid)
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "开放商户电费：" } },
                        [
                          _c("el-switch", {
                            attrs: {
                              "active-value": 1,
                              "inactive-value": 0,
                              disabled:
                                _vm.merchantElectricityAuthLoading ||
                                _vm.merchantElectricityAuthSaving,
                            },
                            on: { change: _vm.onMerchantElectricityAuthChange },
                            model: {
                              value: _vm.merchantElectricityAuthObj.has_access,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.merchantElectricityAuthObj,
                                  "has_access",
                                  $$v
                                )
                              },
                              expression:
                                "merchantElectricityAuthObj.has_access",
                            },
                          }),
                          _vm._v(" "),
                          _vm.merchantElectricityAuthSaving
                            ? _c(
                                "span",
                                { staticClass: "text-gray fs-s2 ml-10" },
                                [_vm._v("保存中...")]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "fs-s2 text-gray" }, [
                        _vm._v(
                          "开启后，该代理及其下级可在小程序使用「商户电费」「电费配置」功能。"
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.merchantElectricityAuthDialog = false
                        },
                      },
                    },
                    [_vm._v("关 闭")]
                  ),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "el-dialog",
            {
              attrs: { title: "免费店员", visible: _vm.freeDialog },
              on: {
                "update:visible": function ($event) {
                  _vm.freeDialog = $event
                },
              },
            },
            [
              _c(
                "el-form",
                { attrs: { "label-width": "150px" } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "免费名额：" } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.freeObj.member_num,
                          callback: function ($$v) {
                            _vm.$set(_vm.freeObj, "member_num", $$v)
                          },
                          expression: "freeObj.member_num",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "每天使用次数：" } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.freeObj.member_day_count,
                          callback: function ($$v) {
                            _vm.$set(_vm.freeObj, "member_day_count", $$v)
                          },
                          expression: "freeObj.member_day_count",
                        },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "fs-s2 text-gray" }, [
                        _vm._v(
                          "注：名额不可超过" +
                            _vm._s(_vm.agentInfo.member_num) +
                            "个，每天使用次数不可超过" +
                            _vm._s(_vm.agentInfo.member_day_count) +
                            "次。"
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "每次最高使用时长：" } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.freeObj.member_free_due_hours,
                          callback: function ($$v) {
                            _vm.$set(_vm.freeObj, "member_free_due_hours", $$v)
                          },
                          expression: "freeObj.member_free_due_hours",
                        },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "fs-s2 text-gray" }, [
                        _vm._v("注：超过最高时长将按正常计费。"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.freeDialog = false
                        },
                      },
                    },
                    [_vm._v("取 消")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.toEdit({ type: 6 }, _vm.freeObj)
                        },
                      },
                    },
                    [_vm._v("确 定")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-dialog",
            {
              attrs: { title: "地图图标设置", visible: _vm.iconDialog },
              on: {
                "update:visible": function ($event) {
                  _vm.iconDialog = $event
                },
              },
            },
            [
              _c(
                "el-form",
                { attrs: { "label-width": "auto" } },
                _vm._l(_vm.deviceNameObj, function (item, index) {
                  return _c(
                    "el-form-item",
                    { attrs: { label: index + "(25*25)：" } },
                    [
                      _c("upload", {
                        model: {
                          value: _vm.brand_icon["device_url_" + item],
                          callback: function ($$v) {
                            _vm.$set(_vm.brand_icon, "device_url_" + item, $$v)
                          },
                          expression: "brand_icon[`device_url_${item}`]",
                        },
                      }),
                    ],
                    1
                  )
                }),
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.iconDialog = false
                        },
                      },
                    },
                    [_vm._v("取 消")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.editDtIcon()
                        },
                      },
                    },
                    [_vm._v("确 定")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-dialog",
            {
              attrs: { title: "账号设置", visible: _vm.isFrozenDialog },
              on: {
                "update:visible": function ($event) {
                  _vm.isFrozenDialog = $event
                },
              },
            },
            [
              _c(
                "el-form",
                { attrs: { "label-width": "200px" } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "账号设置：" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.isFrozenObj.is_frozen,
                            callback: function ($$v) {
                              _vm.$set(_vm.isFrozenObj, "is_frozen", $$v)
                            },
                            expression: "isFrozenObj.is_frozen",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: 0 } }, [
                            _vm._v("解冻账号"),
                          ]),
                          _vm._v(" "),
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v("冻结账号"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.getToken("agent_id") == 173
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "是否允许银行卡提现：" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.isFrozenObj.is_allow_withdrawal,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.isFrozenObj,
                                    "is_allow_withdrawal",
                                    $$v
                                  )
                                },
                                expression: "isFrozenObj.is_allow_withdrawal",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: 0 } }, [
                                _vm._v("否"),
                              ]),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v("是"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "是否使用廉价套餐：" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.isFrozenObj.is_use_cheap,
                            callback: function ($$v) {
                              _vm.$set(_vm.isFrozenObj, "is_use_cheap", $$v)
                            },
                            expression: "isFrozenObj.is_use_cheap",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: 0 } }, [
                            _vm._v("否"),
                          ]),
                          _vm._v(" "),
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v("是"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "清除提现绑定的微信：" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          on: {
                            change: function ($event) {
                              return _vm.show_confirm()
                            },
                          },
                          model: {
                            value: _vm.is_clear_wx_user,
                            callback: function ($$v) {
                              _vm.is_clear_wx_user = $$v
                            },
                            expression: "is_clear_wx_user",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: 0 } }, [
                            _vm._v("否"),
                          ]),
                          _vm._v(" "),
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v("是"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.getToken("agent_id") == 173
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "流量卡收费设置：" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.isFrozenObj.card_charges_type,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.isFrozenObj,
                                    "card_charges_type",
                                    $$v
                                  )
                                },
                                expression: "isFrozenObj.card_charges_type",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: 0 } }, [
                                _vm._v("不收费"),
                              ]),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v("按月"),
                              ]),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: 2 } }, [
                                _vm._v("按季度"),
                              ]),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: 3 } }, [
                                _vm._v("按年"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.getToken("agent_id") == 173
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "流量卡-充电桩2路：" } },
                        [
                          _c(
                            "el-input",
                            {
                              staticClass: "flex1",
                              attrs: {
                                oninput: "value=value.replace(/[^\\d.]/g,'')",
                              },
                              model: {
                                value: _vm.isFrozenObj.second_charge,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.isFrozenObj,
                                    "second_charge",
                                    $$v
                                  )
                                },
                                expression: "isFrozenObj.second_charge",
                              },
                            },
                            [
                              _c("template", { slot: "append" }, [
                                _vm._v("元"),
                              ]),
                            ],
                            2
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.getToken("agent_id") == 173
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "流量卡-充电桩10路：" } },
                        [
                          _c(
                            "el-input",
                            {
                              staticClass: "flex1",
                              attrs: {
                                oninput: "value=value.replace(/[^\\d.]/g,'')",
                              },
                              model: {
                                value: _vm.isFrozenObj.ten_charge,
                                callback: function ($$v) {
                                  _vm.$set(_vm.isFrozenObj, "ten_charge", $$v)
                                },
                                expression: "isFrozenObj.ten_charge",
                              },
                            },
                            [
                              _c("template", { slot: "append" }, [
                                _vm._v("元"),
                              ]),
                            ],
                            2
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.getToken("agent_id") == 173
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "流量卡-充电桩16路：" } },
                        [
                          _c(
                            "el-input",
                            {
                              staticClass: "flex1",
                              attrs: {
                                oninput: "value=value.replace(/[^\\d.]/g,'')",
                              },
                              model: {
                                value: _vm.isFrozenObj.six_charge,
                                callback: function ($$v) {
                                  _vm.$set(_vm.isFrozenObj, "six_charge", $$v)
                                },
                                expression: "isFrozenObj.six_charge",
                              },
                            },
                            [
                              _c("template", { slot: "append" }, [
                                _vm._v("元"),
                              ]),
                            ],
                            2
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.getToken("agent_id") == 173
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "流量卡-充电宝：" } },
                        [
                          _c(
                            "el-input",
                            {
                              staticClass: "flex1",
                              attrs: {
                                oninput: "value=value.replace(/[^\\d.]/g,'')",
                              },
                              model: {
                                value: _vm.isFrozenObj.cdb_charge,
                                callback: function ($$v) {
                                  _vm.$set(_vm.isFrozenObj, "cdb_charge", $$v)
                                },
                                expression: "isFrozenObj.cdb_charge",
                              },
                            },
                            [
                              _c("template", { slot: "append" }, [
                                _vm._v("元"),
                              ]),
                            ],
                            2
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.isFrozenDialog = false
                        },
                      },
                    },
                    [_vm._v("取 消")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.setIsFrozen()
                        },
                      },
                    },
                    [_vm._v("确 定")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-dialog",
            {
              attrs: {
                title: "账号设置",
                visible: _vm.terminalAccountSettingVisible,
                width: "500px",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.terminalAccountSettingVisible = $event
                },
              },
            },
            [
              _c(
                "el-form",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.terminalAccountLoading,
                      expression: "terminalAccountLoading",
                    },
                  ],
                  attrs: { "label-width": "240px" },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "禁用代理及名下所有账号：" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.terminalAccountObj.is_disable_account,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.terminalAccountObj,
                                "is_disable_account",
                                $$v
                              )
                            },
                            expression: "terminalAccountObj.is_disable_account",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: 0 } }, [
                            _vm._v("否"),
                          ]),
                          _vm._v(" "),
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v("是"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "禁用代理及名下所有设备：" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.terminalAccountObj.is_disable_equipment,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.terminalAccountObj,
                                "is_disable_equipment",
                                $$v
                              )
                            },
                            expression:
                              "terminalAccountObj.is_disable_equipment",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: 0 } }, [
                            _vm._v("否"),
                          ]),
                          _vm._v(" "),
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v("是"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "禁用当前账号：" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.terminalAccountObj.is_frozen,
                            callback: function ($$v) {
                              _vm.$set(_vm.terminalAccountObj, "is_frozen", $$v)
                            },
                            expression: "terminalAccountObj.is_frozen",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: 0 } }, [
                            _vm._v("否"),
                          ]),
                          _vm._v(" "),
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v("是"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.terminalAccountSettingVisible = false
                        },
                      },
                    },
                    [_vm._v("取 消")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        loading: _vm.terminalAccountSaving,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.saveTerminalAccountSetting()
                        },
                      },
                    },
                    [_vm._v("确 定")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-dialog",
            {
              attrs: { title: "余额增值", visible: _vm.isYezzDialog },
              on: {
                "update:visible": function ($event) {
                  _vm.isYezzDialog = $event
                },
              },
            },
            [
              _c(
                "el-form",
                { attrs: { "label-width": "150px" } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "最大增值比例：" } },
                    [
                      _c(
                        "el-input",
                        {
                          staticClass: "flex1",
                          attrs: {
                            oninput:
                              "value=value>100 ? 100 : value.replace(/[^0-9]/g, '')",
                          },
                          model: {
                            value: _vm.isYezzObj.max_steal_order_right_ration,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.isYezzObj,
                                "max_steal_order_right_ration",
                                $$v
                              )
                            },
                            expression:
                              "isYezzObj.max_steal_order_right_ration",
                          },
                        },
                        [_c("template", { slot: "append" }, [_vm._v("%")])],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form",
                { attrs: { "label-width": "150px" } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "余额增值设置：" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.isYezzObj.is_yezz,
                            callback: function ($$v) {
                              _vm.$set(_vm.isYezzObj, "is_yezz", $$v)
                            },
                            expression: "isYezzObj.is_yezz",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: 0 } }, [
                            _vm._v("开启"),
                          ]),
                          _vm._v(" "),
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v("关闭"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.isYezzDialog = false
                        },
                      },
                    },
                    [_vm._v("取 消")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.setIsYezz()
                        },
                      },
                    },
                    [_vm._v("确 定")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-dialog",
            {
              attrs: {
                title: "添加推荐官",
                visible: _vm.addPromoterAgentDialog,
              },
              on: {
                "update:visible": function ($event) {
                  _vm.addPromoterAgentDialog = $event
                },
              },
            },
            [
              _c(
                "el-form",
                { attrs: { "label-width": "150px" } },
                [
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "推荐官姓名：" } },
                      [
                        _c("el-input", {
                          staticClass: "flex1",
                          model: {
                            value: _vm.addPromoterAgentObj.name,
                            callback: function ($$v) {
                              _vm.$set(_vm.addPromoterAgentObj, "name", $$v)
                            },
                            expression: "addPromoterAgentObj.name",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  _vm._v(" "),
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "手机号码：" } },
                      [
                        _c("el-input", {
                          staticClass: "flex1",
                          model: {
                            value: _vm.addPromoterAgentObj.phone,
                            callback: function ($$v) {
                              _vm.$set(_vm.addPromoterAgentObj, "phone", $$v)
                            },
                            expression: "addPromoterAgentObj.phone",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  _vm._v(" "),
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "分成比例：" } },
                      [
                        _c(
                          "el-input",
                          {
                            staticClass: "flex1",
                            attrs: {
                              oninput:
                                "value=value > 100 ? 100 : value.replace(/[^0-9]/g, '')",
                            },
                            model: {
                              value: _vm.addPromoterAgentObj.agent_percent,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.addPromoterAgentObj,
                                  "agent_percent",
                                  $$v
                                )
                              },
                              expression: "addPromoterAgentObj.agent_percent",
                            },
                          },
                          [_c("template", { slot: "append" }, [_vm._v("%")])],
                          2
                        ),
                      ],
                      1
                    ),
                  ],
                  _vm._v(" "),
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "状态：" } },
                      [
                        _c(
                          "el-radio-group",
                          {
                            model: {
                              value: _vm.addPromoterAgentObj.is_delete,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.addPromoterAgentObj,
                                  "is_delete",
                                  $$v
                                )
                              },
                              expression: "addPromoterAgentObj.is_delete",
                            },
                          },
                          [
                            _c("el-radio", { attrs: { label: 0 } }, [
                              _vm._v("启用"),
                            ]),
                            _vm._v(" "),
                            _c("el-radio", { attrs: { label: 1 } }, [
                              _vm._v("禁用"),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "备注：" } },
                    [
                      _c("el-input", {
                        staticClass: "flex1",
                        model: {
                          value: _vm.addPromoterAgentObj.remark,
                          callback: function ($$v) {
                            _vm.$set(_vm.addPromoterAgentObj, "remark", $$v)
                          },
                          expression: "addPromoterAgentObj.remark",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.addPromoterAgentDialog = false
                        },
                      },
                    },
                    [_vm._v("取 消")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.addPromoterAgent()
                        },
                      },
                    },
                    [_vm._v("确 定")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-dialog",
            {
              attrs: { title: "设备与收益情况", visible: _vm.isSyqkDialog },
              on: {
                "update:visible": function ($event) {
                  _vm.isSyqkDialog = $event
                },
              },
            },
            [
              [
                _c(
                  "el-row",
                  { staticClass: "fs-s4" },
                  [
                    _c(
                      "el-col",
                      { attrs: { xs: { span: 24 }, sm: { span: 12 } } },
                      _vm._l(_vm.isSyqkObj.device_info, function (item, index) {
                        return _c(
                          "div",
                          {
                            staticClass: "cursor",
                            on: {
                              click: function ($event) {
                                _vm.isSyqkDialog = false
                                _vm.$router.push({
                                  path:
                                    "/equipment/subEquipment?son_id=" +
                                    _vm.isSyqkObj.agent_id,
                                })
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.deviceKeyObj[index]) +
                                "："
                            ),
                            _c("span", { staticClass: "text-blue" }, [
                              _vm._v(_vm._s(item)),
                            ]),
                          ]
                        )
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { xs: { span: 24 }, sm: { span: 12 } } },
                      _vm._l(
                        _vm.isSyqkObj.device_info_d,
                        function (item, index) {
                          return _c("div", [
                            item > 0
                              ? _c("span", [
                                  _vm._v(_vm._s(index) + "："),
                                  _c("span", [_vm._v(_vm._s(item))]),
                                ])
                              : _vm._e(),
                          ])
                        }
                      ),
                      0
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "cursor",
                    on: {
                      click: function ($event) {
                        _vm.isSyqkDialog = false
                        _vm.$router.push({
                          path: "/home/income?son_id=" + _vm.isSyqkObj.agent_id,
                        })
                      },
                    },
                  },
                  [
                    _vm._v("\n            收益金额："),
                    _c("span", { staticClass: "text-blue" }, [
                      _vm._v(_vm._s(_vm.isSyqkObj.income || "0.00") + "元"),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "cursor",
                    on: {
                      click: function ($event) {
                        return _vm.toEdit({
                          id: _vm.isSyqkObj.agent_id,
                          type: 2,
                        })
                      },
                    },
                  },
                  [
                    _vm._v("冻结金额："),
                    _c("span", { staticClass: "text-blue" }, [
                      _vm._v(_vm._s(_vm.isSyqkObj.freez_money) + "元"),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "cursor" }, [
                  _vm._v("账户余额："),
                  _c("span", [_vm._v(_vm._s(_vm.isSyqkObj.money) + "元")]),
                ]),
              ],
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.isSyqkDialog = false
                        },
                      },
                    },
                    [_vm._v("关 闭")]
                  ),
                ],
                1
              ),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "el-dialog",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.calculateCostLoading,
                  expression: "calculateCostLoading",
                },
              ],
              attrs: {
                title: "",
                visible: _vm.breakEvenDialog,
                width: "90%",
                center: "",
                "title-class": "dialog-title-bold",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.breakEvenDialog = $event
                },
              },
            },
            [
              _c("h2", { staticStyle: { "text-align": "center" } }, [
                _vm._v("设备盈利状态测算"),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "calculator-container" }, [
                _c(
                  "div",
                  {
                    staticClass: "info-card card-shadow card-elevation",
                    staticStyle: {
                      "background-color": "#FAFAFC",
                      padding: "8px",
                      "border-radius": "12px",
                    },
                  },
                  [
                    _c("h3", [_vm._v("代理信息")]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "flex align-items-center" },
                      [
                        _c("span", [
                          _vm._v("  "),
                          _c("strong", [_vm._v("代理ID ：")]),
                          _vm._v(_vm._s(_vm.currentShopInfo.id)),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "ml-20" }, [
                          _vm._v("  "),
                          _c("strong", [_vm._v("代理名称：")]),
                          _vm._v(_vm._s(_vm.currentShopInfo.store_name)),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "ml-20" }, [
                          _vm._v("  "),
                          _c("strong", [_vm._v("设备类型：")]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "el-select",
                          {
                            staticStyle: {
                              width: "120px",
                              "margin-left": "10px",
                            },
                            attrs: {
                              placeholder: "请选择设备类型",
                              size: "mini",
                            },
                            on: { change: _vm.getCalculateTotalCost },
                            model: {
                              value: _vm.selectedDeviceType,
                              callback: function ($$v) {
                                _vm.selectedDeviceType = $$v
                              },
                              expression: "selectedDeviceType",
                            },
                          },
                          _vm._l(_vm.deviceTypeOptions, function (item) {
                            return _c("el-option", {
                              key: item.value,
                              attrs: { label: item.label, value: item.value },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("hr"),
                    _vm._v(" "),
                    _c("div", [
                      _c("div", [_c("strong", [_vm._v("   设备数量")])]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "flex align-items-center mt-2" }, [
                      _c(
                        "div",
                        { staticClass: "flex-wrap" },
                        [
                          _vm.selectedDeviceType != 0
                            ? [
                                _c("div", [
                                  _vm.currentShopInfo.cdbcount > 0 &&
                                  _vm.selectedDeviceType == 1
                                    ? _c("div", { staticClass: "device-row" }, [
                                        _c(
                                          "div",
                                          { staticClass: "device-info" },
                                          [
                                            _vm._v(
                                              "4G充电宝 " +
                                                _vm._s(
                                                  _vm.currentShopInfo.cdbcount
                                                ) +
                                                " 台"
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "device-costs" },
                                          [
                                            _c(
                                              "el-input",
                                              {
                                                staticStyle: { width: "165px" },
                                                attrs: {
                                                  placeholder: "单价",
                                                  size: "mini",
                                                },
                                                on: {
                                                  blur: function ($event) {
                                                    return _vm.calculateDeviceTotalCostByType(
                                                      "cdbCost"
                                                    )
                                                  },
                                                  input: function ($event) {
                                                    return _vm.validateNumber(
                                                      $event,
                                                      "cdbCost"
                                                    )
                                                  },
                                                },
                                                model: {
                                                  value: _vm.costForm.cdbCost,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.costForm,
                                                      "cdbCost",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "costForm.cdbCost",
                                                },
                                              },
                                              [
                                                _c(
                                                  "template",
                                                  { slot: "prepend" },
                                                  [_vm._v("单个设备成本")]
                                                ),
                                              ],
                                              2
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "el-input",
                                              {
                                                staticStyle: { width: "185px" },
                                                attrs: {
                                                  placeholder: "单价",
                                                  size: "mini",
                                                },
                                                on: {
                                                  blur: function ($event) {
                                                    return _vm.calcDeviceInstallationTotalCostByType(
                                                      "cdbInstallCost"
                                                    )
                                                  },
                                                  input: function ($event) {
                                                    return _vm.validateNumber(
                                                      $event,
                                                      "cdbInstallCost"
                                                    )
                                                  },
                                                },
                                                model: {
                                                  value:
                                                    _vm.costForm.cdbInstallCost,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.costForm,
                                                      "cdbInstallCost",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "costForm.cdbInstallCost",
                                                },
                                              },
                                              [
                                                _c(
                                                  "template",
                                                  { slot: "prepend" },
                                                  [_vm._v("单个安装费用")]
                                                ),
                                              ],
                                              2
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "el-input",
                                              {
                                                staticStyle: { width: "185px" },
                                                attrs: {
                                                  placeholder: "单价",
                                                  size: "mini",
                                                },
                                                on: {
                                                  blur: function ($event) {
                                                    return _vm.calcDeviceLaborTotalCostByType(
                                                      "cdbLaborCost"
                                                    )
                                                  },
                                                  input: function ($event) {
                                                    return _vm.validateNumber(
                                                      $event,
                                                      "cdbLaborCost"
                                                    )
                                                  },
                                                },
                                                model: {
                                                  value:
                                                    _vm.costForm.cdbLaborCost,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.costForm,
                                                      "cdbLaborCost",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "costForm.cdbLaborCost",
                                                },
                                              },
                                              [
                                                _c(
                                                  "template",
                                                  { slot: "prepend" },
                                                  [_vm._v("单个人工成本")]
                                                ),
                                              ],
                                              2
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "el-input",
                                              {
                                                staticStyle: { width: "185px" },
                                                attrs: {
                                                  placeholder: "单价",
                                                  size: "mini",
                                                },
                                                on: {
                                                  blur: function ($event) {
                                                    return _vm.calcDeviceOtherTotalCostByType(
                                                      "cdbOtherCost"
                                                    )
                                                  },
                                                  input: function ($event) {
                                                    return _vm.validateNumber(
                                                      $event,
                                                      "cdbOtherCost"
                                                    )
                                                  },
                                                },
                                                model: {
                                                  value:
                                                    _vm.costForm.cdbOtherCost,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.costForm,
                                                      "cdbOtherCost",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "costForm.cdbOtherCost",
                                                },
                                              },
                                              [
                                                _c(
                                                  "template",
                                                  { slot: "prepend" },
                                                  [_vm._v("单个其他成本")]
                                                ),
                                              ],
                                              2
                                            ),
                                          ],
                                          1
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.currentShopInfo.cdxcount > 0 &&
                                  _vm.selectedDeviceType == 3
                                    ? _c("div", { staticClass: "device-row" }, [
                                        _c(
                                          "div",
                                          { staticClass: "device-info" },
                                          [
                                            _vm._v(
                                              "充电线 " +
                                                _vm._s(
                                                  _vm.currentShopInfo.cdxcount
                                                ) +
                                                " 条"
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "device-costs" },
                                          [
                                            _c(
                                              "el-input",
                                              {
                                                staticStyle: { width: "165px" },
                                                attrs: {
                                                  placeholder: "单价",
                                                  size: "mini",
                                                },
                                                on: {
                                                  blur: function ($event) {
                                                    return _vm.calculateDeviceTotalCostByType(
                                                      "cdxCost"
                                                    )
                                                  },
                                                  input: function ($event) {
                                                    return _vm.validateNumber(
                                                      $event,
                                                      "cdxCost"
                                                    )
                                                  },
                                                },
                                                model: {
                                                  value: _vm.costForm.cdxCost,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.costForm,
                                                      "cdxCost",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "costForm.cdxCost",
                                                },
                                              },
                                              [
                                                _c(
                                                  "template",
                                                  { slot: "prepend" },
                                                  [_vm._v("单个设备成本")]
                                                ),
                                              ],
                                              2
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "el-input",
                                              {
                                                staticStyle: { width: "185px" },
                                                attrs: {
                                                  placeholder: "单价",
                                                  size: "mini",
                                                },
                                                on: {
                                                  blur: function ($event) {
                                                    return _vm.calcDeviceInstallationTotalCostByType(
                                                      "cdxInstallCost"
                                                    )
                                                  },
                                                  input: function ($event) {
                                                    return _vm.validateNumber(
                                                      $event,
                                                      "cdxInstallCost"
                                                    )
                                                  },
                                                },
                                                model: {
                                                  value:
                                                    _vm.costForm.cdxInstallCost,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.costForm,
                                                      "cdxInstallCost",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "costForm.cdxInstallCost",
                                                },
                                              },
                                              [
                                                _c(
                                                  "template",
                                                  { slot: "prepend" },
                                                  [_vm._v("单个安装费用")]
                                                ),
                                              ],
                                              2
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "el-input",
                                              {
                                                staticStyle: { width: "185px" },
                                                attrs: {
                                                  placeholder: "单价",
                                                  size: "mini",
                                                },
                                                on: {
                                                  blur: function ($event) {
                                                    return _vm.calcDeviceLaborTotalCostByType(
                                                      "cdxLaborCost"
                                                    )
                                                  },
                                                  input: function ($event) {
                                                    return _vm.validateNumber(
                                                      $event,
                                                      "cdxLaborCost"
                                                    )
                                                  },
                                                },
                                                model: {
                                                  value:
                                                    _vm.costForm.cdxLaborCost,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.costForm,
                                                      "cdxLaborCost",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "costForm.cdxLaborCost",
                                                },
                                              },
                                              [
                                                _c(
                                                  "template",
                                                  { slot: "prepend" },
                                                  [_vm._v("单个人工成本")]
                                                ),
                                              ],
                                              2
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "el-input",
                                              {
                                                staticStyle: { width: "185px" },
                                                attrs: {
                                                  placeholder: "单价",
                                                  size: "mini",
                                                },
                                                on: {
                                                  blur: function ($event) {
                                                    return _vm.calcDeviceOtherTotalCostByType(
                                                      "cdxOtherCost"
                                                    )
                                                  },
                                                  input: function ($event) {
                                                    return _vm.validateNumber(
                                                      $event,
                                                      "cdxOtherCost"
                                                    )
                                                  },
                                                },
                                                model: {
                                                  value:
                                                    _vm.costForm.cdxOtherCost,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.costForm,
                                                      "cdxOtherCost",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "costForm.cdxOtherCost",
                                                },
                                              },
                                              [
                                                _c(
                                                  "template",
                                                  { slot: "prepend" },
                                                  [_vm._v("单个其他成本")]
                                                ),
                                              ],
                                              2
                                            ),
                                          ],
                                          1
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.currentShopInfo.cdz10count > 0 &&
                                  _vm.selectedDeviceType == 5
                                    ? _c("div", { staticClass: "device-row" }, [
                                        _c(
                                          "div",
                                          { staticClass: "device-info" },
                                          [
                                            _vm._v(
                                              "10路桩 " +
                                                _vm._s(
                                                  _vm.currentShopInfo.cdz10count
                                                ) +
                                                " 台"
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "device-costs" },
                                          [
                                            _c(
                                              "el-input",
                                              {
                                                staticStyle: { width: "165px" },
                                                attrs: {
                                                  placeholder: "单价",
                                                  size: "mini",
                                                },
                                                on: {
                                                  blur: function ($event) {
                                                    return _vm.calculateDeviceTotalCostByType(
                                                      "cdz10Cost"
                                                    )
                                                  },
                                                  input: function ($event) {
                                                    return _vm.validateNumber(
                                                      $event,
                                                      "cdz10Cost"
                                                    )
                                                  },
                                                },
                                                model: {
                                                  value: _vm.costForm.cdz10Cost,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.costForm,
                                                      "cdz10Cost",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "costForm.cdz10Cost",
                                                },
                                              },
                                              [
                                                _c(
                                                  "template",
                                                  { slot: "prepend" },
                                                  [_vm._v("单个设备成本")]
                                                ),
                                              ],
                                              2
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "el-input",
                                              {
                                                staticStyle: { width: "185px" },
                                                attrs: {
                                                  placeholder: "单价",
                                                  size: "mini",
                                                },
                                                on: {
                                                  blur: function ($event) {
                                                    return _vm.calcDeviceInstallationTotalCostByType(
                                                      "cdz10InstallCost"
                                                    )
                                                  },
                                                  input: function ($event) {
                                                    return _vm.validateNumber(
                                                      $event,
                                                      "cdz10InstallCost"
                                                    )
                                                  },
                                                },
                                                model: {
                                                  value:
                                                    _vm.costForm
                                                      .cdz10InstallCost,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.costForm,
                                                      "cdz10InstallCost",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "costForm.cdz10InstallCost",
                                                },
                                              },
                                              [
                                                _c(
                                                  "template",
                                                  { slot: "prepend" },
                                                  [_vm._v("单个安装费用")]
                                                ),
                                              ],
                                              2
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "el-input",
                                              {
                                                staticStyle: { width: "185px" },
                                                attrs: {
                                                  placeholder: "单价",
                                                  size: "mini",
                                                },
                                                on: {
                                                  blur: function ($event) {
                                                    return _vm.calcDeviceLaborTotalCostByType(
                                                      "cdz10LaborCost"
                                                    )
                                                  },
                                                  input: function ($event) {
                                                    return _vm.validateNumber(
                                                      $event,
                                                      "cdz10LaborCost"
                                                    )
                                                  },
                                                },
                                                model: {
                                                  value:
                                                    _vm.costForm.cdz10LaborCost,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.costForm,
                                                      "cdz10LaborCost",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "costForm.cdz10LaborCost",
                                                },
                                              },
                                              [
                                                _c(
                                                  "template",
                                                  { slot: "prepend" },
                                                  [_vm._v("单个人工成本")]
                                                ),
                                              ],
                                              2
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "el-input",
                                              {
                                                staticStyle: { width: "185px" },
                                                attrs: {
                                                  placeholder: "单价",
                                                  size: "mini",
                                                },
                                                on: {
                                                  blur: function ($event) {
                                                    return _vm.calcDeviceOtherTotalCostByType(
                                                      "cdz10OtherCost"
                                                    )
                                                  },
                                                  input: function ($event) {
                                                    return _vm.validateNumber(
                                                      $event,
                                                      "cdz10OtherCost"
                                                    )
                                                  },
                                                },
                                                model: {
                                                  value:
                                                    _vm.costForm.cdz10OtherCost,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.costForm,
                                                      "cdz10OtherCost",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "costForm.cdz10OtherCost",
                                                },
                                              },
                                              [
                                                _c(
                                                  "template",
                                                  { slot: "prepend" },
                                                  [_vm._v("单个其他成本")]
                                                ),
                                              ],
                                              2
                                            ),
                                          ],
                                          1
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.currentShopInfo.cdz2count > 0 &&
                                  _vm.selectedDeviceType == 5
                                    ? _c("div", { staticClass: "device-row" }, [
                                        _c(
                                          "div",
                                          { staticClass: "device-info" },
                                          [
                                            _vm._v(
                                              "2路4G " +
                                                _vm._s(
                                                  _vm.currentShopInfo.cdz2count
                                                ) +
                                                " 个"
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "device-costs" },
                                          [
                                            _c(
                                              "el-input",
                                              {
                                                staticStyle: { width: "165px" },
                                                attrs: {
                                                  placeholder: "单价",
                                                  size: "mini",
                                                },
                                                on: {
                                                  blur: function ($event) {
                                                    return _vm.calculateDeviceTotalCostByType(
                                                      "cdz2Cost"
                                                    )
                                                  },
                                                  input: function ($event) {
                                                    return _vm.validateNumber(
                                                      $event,
                                                      "cdz2Cost"
                                                    )
                                                  },
                                                },
                                                model: {
                                                  value: _vm.costForm.cdz2Cost,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.costForm,
                                                      "cdz2Cost",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "costForm.cdz2Cost",
                                                },
                                              },
                                              [
                                                _c(
                                                  "template",
                                                  { slot: "prepend" },
                                                  [_vm._v("单个设备成本")]
                                                ),
                                              ],
                                              2
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "el-input",
                                              {
                                                staticStyle: { width: "185px" },
                                                attrs: {
                                                  placeholder: "单价",
                                                  size: "mini",
                                                },
                                                on: {
                                                  blur: function ($event) {
                                                    return _vm.calcDeviceInstallationTotalCostByType(
                                                      "cdz2InstallCost"
                                                    )
                                                  },
                                                  input: function ($event) {
                                                    return _vm.validateNumber(
                                                      $event,
                                                      "cdz2InstallCost"
                                                    )
                                                  },
                                                },
                                                model: {
                                                  value:
                                                    _vm.costForm
                                                      .cdz2InstallCost,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.costForm,
                                                      "cdz2InstallCost",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "costForm.cdz2InstallCost",
                                                },
                                              },
                                              [
                                                _c(
                                                  "template",
                                                  { slot: "prepend" },
                                                  [_vm._v("单个安装费用")]
                                                ),
                                              ],
                                              2
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "el-input",
                                              {
                                                staticStyle: { width: "185px" },
                                                attrs: {
                                                  placeholder: "单价",
                                                  size: "mini",
                                                },
                                                on: {
                                                  blur: function ($event) {
                                                    return _vm.calcDeviceLaborTotalCostByType(
                                                      "cdz2LaborCost"
                                                    )
                                                  },
                                                  input: function ($event) {
                                                    return _vm.validateNumber(
                                                      $event,
                                                      "cdz2LaborCost"
                                                    )
                                                  },
                                                },
                                                model: {
                                                  value:
                                                    _vm.costForm.cdz2LaborCost,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.costForm,
                                                      "cdz2LaborCost",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "costForm.cdz2LaborCost",
                                                },
                                              },
                                              [
                                                _c(
                                                  "template",
                                                  { slot: "prepend" },
                                                  [_vm._v("单个人工成本")]
                                                ),
                                              ],
                                              2
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "el-input",
                                              {
                                                staticStyle: { width: "185px" },
                                                attrs: {
                                                  placeholder: "单价",
                                                  size: "mini",
                                                },
                                                on: {
                                                  blur: function ($event) {
                                                    return _vm.calcDeviceOtherTotalCostByType(
                                                      "cdz2OtherCost"
                                                    )
                                                  },
                                                  input: function ($event) {
                                                    return _vm.validateNumber(
                                                      $event,
                                                      "cdz2OtherCost"
                                                    )
                                                  },
                                                },
                                                model: {
                                                  value:
                                                    _vm.costForm.cdz2OtherCost,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.costForm,
                                                      "cdz2OtherCost",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "costForm.cdz2OtherCost",
                                                },
                                              },
                                              [
                                                _c(
                                                  "template",
                                                  { slot: "prepend" },
                                                  [_vm._v("单个其他成本")]
                                                ),
                                              ],
                                              2
                                            ),
                                          ],
                                          1
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.currentShopInfo.cdz2lycount > 0 &&
                                  _vm.selectedDeviceType == 5
                                    ? _c("div", { staticClass: "device-row" }, [
                                        _c(
                                          "div",
                                          { staticClass: "device-info" },
                                          [
                                            _vm._v(
                                              "2路蓝牙 " +
                                                _vm._s(
                                                  _vm.currentShopInfo
                                                    .cdz2lycount
                                                ) +
                                                " 个"
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "device-costs" },
                                          [
                                            _c(
                                              "el-input",
                                              {
                                                staticStyle: { width: "165px" },
                                                attrs: {
                                                  placeholder: "单价",
                                                  size: "mini",
                                                },
                                                on: {
                                                  blur: function ($event) {
                                                    return _vm.calculateDeviceTotalCostByType(
                                                      "cdz2lyCost"
                                                    )
                                                  },
                                                  input: function ($event) {
                                                    return _vm.validateNumber(
                                                      $event,
                                                      "cdz2lyCost"
                                                    )
                                                  },
                                                },
                                                model: {
                                                  value:
                                                    _vm.costForm.cdz2lyCost,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.costForm,
                                                      "cdz2lyCost",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "costForm.cdz2lyCost",
                                                },
                                              },
                                              [
                                                _c(
                                                  "template",
                                                  { slot: "prepend" },
                                                  [_vm._v("单个设备成本")]
                                                ),
                                              ],
                                              2
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "el-input",
                                              {
                                                staticStyle: { width: "185px" },
                                                attrs: {
                                                  placeholder: "单价",
                                                  size: "mini",
                                                },
                                                on: {
                                                  blur: function ($event) {
                                                    return _vm.calcDeviceInstallationTotalCostByType(
                                                      "cdz2lybInstallCost"
                                                    )
                                                  },
                                                  input: function ($event) {
                                                    return _vm.validateNumber(
                                                      $event,
                                                      "cdz2lybInstallCost"
                                                    )
                                                  },
                                                },
                                                model: {
                                                  value:
                                                    _vm.costForm
                                                      .cdz2lybInstallCost,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.costForm,
                                                      "cdz2lybInstallCost",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "costForm.cdz2lybInstallCost",
                                                },
                                              },
                                              [
                                                _c(
                                                  "template",
                                                  { slot: "prepend" },
                                                  [_vm._v("单个安装费用")]
                                                ),
                                              ],
                                              2
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "el-input",
                                              {
                                                staticStyle: { width: "185px" },
                                                attrs: {
                                                  placeholder: "单价",
                                                  size: "mini",
                                                },
                                                on: {
                                                  blur: function ($event) {
                                                    return _vm.calcDeviceLaborTotalCostByType(
                                                      "cdz2lybLaborCost"
                                                    )
                                                  },
                                                  input: function ($event) {
                                                    return _vm.validateNumber(
                                                      $event,
                                                      "cdz2lybLaborCost"
                                                    )
                                                  },
                                                },
                                                model: {
                                                  value:
                                                    _vm.costForm
                                                      .cdz2lybLaborCost,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.costForm,
                                                      "cdz2lybLaborCost",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "costForm.cdz2lybLaborCost",
                                                },
                                              },
                                              [
                                                _c(
                                                  "template",
                                                  { slot: "prepend" },
                                                  [_vm._v("单个人工成本")]
                                                ),
                                              ],
                                              2
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "el-input",
                                              {
                                                staticStyle: { width: "185px" },
                                                attrs: {
                                                  placeholder: "单价",
                                                  size: "mini",
                                                },
                                                on: {
                                                  blur: function ($event) {
                                                    return _vm.calcDeviceOtherTotalCostByType(
                                                      "cdz2lybOtherCost"
                                                    )
                                                  },
                                                  input: function ($event) {
                                                    return _vm.validateNumber(
                                                      $event,
                                                      "cdz2lybOtherCost"
                                                    )
                                                  },
                                                },
                                                model: {
                                                  value:
                                                    _vm.costForm
                                                      .cdz2lybOtherCost,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.costForm,
                                                      "cdz2lybOtherCost",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "costForm.cdz2lybOtherCost",
                                                },
                                              },
                                              [
                                                _c(
                                                  "template",
                                                  { slot: "prepend" },
                                                  [_vm._v("单个其他成本")]
                                                ),
                                              ],
                                              2
                                            ),
                                          ],
                                          1
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.currentShopInfo.cdz2hpcount > 0 &&
                                  _vm.selectedDeviceType == 5
                                    ? _c("div", { staticClass: "device-row" }, [
                                        _c(
                                          "div",
                                          { staticClass: "device-info" },
                                          [
                                            _vm._v(
                                              "2路大功率 " +
                                                _vm._s(
                                                  _vm.currentShopInfo
                                                    .cdz2hpcount
                                                ) +
                                                " 个"
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "device-costs" },
                                          [
                                            _c(
                                              "el-input",
                                              {
                                                staticStyle: { width: "165px" },
                                                attrs: {
                                                  placeholder: "单价",
                                                  size: "mini",
                                                },
                                                on: {
                                                  blur: function ($event) {
                                                    return _vm.calculateDeviceTotalCostByType(
                                                      "cdz2hpCost"
                                                    )
                                                  },
                                                  input: function ($event) {
                                                    return _vm.validateNumber(
                                                      $event,
                                                      "cdz2hpCost"
                                                    )
                                                  },
                                                },
                                                model: {
                                                  value:
                                                    _vm.costForm.cdz2hpCost,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.costForm,
                                                      "cdz2hpCost",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "costForm.cdz2hpCost",
                                                },
                                              },
                                              [
                                                _c(
                                                  "template",
                                                  { slot: "prepend" },
                                                  [_vm._v("单个设备成本")]
                                                ),
                                              ],
                                              2
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "el-input",
                                              {
                                                staticStyle: { width: "185px" },
                                                attrs: {
                                                  placeholder: "单价",
                                                  size: "mini",
                                                },
                                                on: {
                                                  blur: function ($event) {
                                                    return _vm.calcDeviceInstallationTotalCostByType(
                                                      "cdz2hpInstallCost"
                                                    )
                                                  },
                                                  input: function ($event) {
                                                    return _vm.validateNumber(
                                                      $event,
                                                      "cdz2hpInstallCost"
                                                    )
                                                  },
                                                },
                                                model: {
                                                  value:
                                                    _vm.costForm
                                                      .cdz2hpInstallCost,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.costForm,
                                                      "cdz2hpInstallCost",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "costForm.cdz2hpInstallCost",
                                                },
                                              },
                                              [
                                                _c(
                                                  "template",
                                                  { slot: "prepend" },
                                                  [_vm._v("单个安装费用")]
                                                ),
                                              ],
                                              2
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "el-input",
                                              {
                                                staticStyle: { width: "185px" },
                                                attrs: {
                                                  placeholder: "单价",
                                                  size: "mini",
                                                },
                                                on: {
                                                  blur: function ($event) {
                                                    return _vm.calcDeviceLaborTotalCostByType(
                                                      "cdz2hpLaborCost"
                                                    )
                                                  },
                                                  input: function ($event) {
                                                    return _vm.validateNumber(
                                                      $event,
                                                      "cdz2hpLaborCost"
                                                    )
                                                  },
                                                },
                                                model: {
                                                  value:
                                                    _vm.costForm
                                                      .cdz2hpLaborCost,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.costForm,
                                                      "cdz2hpLaborCost",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "costForm.cdz2hpLaborCost",
                                                },
                                              },
                                              [
                                                _c(
                                                  "template",
                                                  { slot: "prepend" },
                                                  [_vm._v("单个人工成本")]
                                                ),
                                              ],
                                              2
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "el-input",
                                              {
                                                staticStyle: { width: "185px" },
                                                attrs: {
                                                  placeholder: "单价",
                                                  size: "mini",
                                                },
                                                on: {
                                                  blur: function ($event) {
                                                    return _vm.calcDeviceOtherTotalCostByType(
                                                      "cdz2hpOtherCost"
                                                    )
                                                  },
                                                  input: function ($event) {
                                                    return _vm.validateNumber(
                                                      $event,
                                                      "cdz2hpOtherCost"
                                                    )
                                                  },
                                                },
                                                model: {
                                                  value:
                                                    _vm.costForm
                                                      .cdz2hpOtherCost,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.costForm,
                                                      "cdz2hpOtherCost",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "costForm.cdz2hpOtherCost",
                                                },
                                              },
                                              [
                                                _c(
                                                  "template",
                                                  { slot: "prepend" },
                                                  [_vm._v("单个其他成本")]
                                                ),
                                              ],
                                              2
                                            ),
                                          ],
                                          1
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.currentShopInfo.zmcdbcount > 0 &&
                                  _vm.selectedDeviceType == 1
                                    ? _c("div", { staticClass: "device-row" }, [
                                        _c(
                                          "div",
                                          { staticClass: "device-info" },
                                          [
                                            _vm._v(
                                              "桌面充电宝 " +
                                                _vm._s(
                                                  _vm.currentShopInfo.zmcdbcount
                                                ) +
                                                " 个"
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "device-costs" },
                                          [
                                            _c(
                                              "el-input",
                                              {
                                                staticStyle: { width: "165px" },
                                                attrs: {
                                                  placeholder: "单价",
                                                  size: "mini",
                                                },
                                                on: {
                                                  blur: function ($event) {
                                                    return _vm.calculateDeviceTotalCostByType(
                                                      "zmcdbCost"
                                                    )
                                                  },
                                                  input: function ($event) {
                                                    return _vm.validateNumber(
                                                      $event,
                                                      "zmcdbCost"
                                                    )
                                                  },
                                                },
                                                model: {
                                                  value: _vm.costForm.zmcdbCost,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.costForm,
                                                      "zmcdbCost",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "costForm.zmcdbCost",
                                                },
                                              },
                                              [
                                                _c(
                                                  "template",
                                                  { slot: "prepend" },
                                                  [_vm._v("单个设备成本")]
                                                ),
                                              ],
                                              2
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "el-input",
                                              {
                                                staticStyle: { width: "185px" },
                                                attrs: {
                                                  placeholder: "单价",
                                                  size: "mini",
                                                },
                                                on: {
                                                  blur: function ($event) {
                                                    return _vm.calcDeviceInstallationTotalCostByType(
                                                      "zmcdbInstallCost"
                                                    )
                                                  },
                                                  input: function ($event) {
                                                    return _vm.validateNumber(
                                                      $event,
                                                      "zmcdbInstallCost"
                                                    )
                                                  },
                                                },
                                                model: {
                                                  value:
                                                    _vm.costForm
                                                      .zmcdbInstallCost,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.costForm,
                                                      "zmcdbInstallCost",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "costForm.zmcdbInstallCost",
                                                },
                                              },
                                              [
                                                _c(
                                                  "template",
                                                  { slot: "prepend" },
                                                  [_vm._v("单个安装费用")]
                                                ),
                                              ],
                                              2
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "el-input",
                                              {
                                                staticStyle: { width: "185px" },
                                                attrs: {
                                                  placeholder: "单价",
                                                  size: "mini",
                                                },
                                                on: {
                                                  blur: function ($event) {
                                                    return _vm.calcDeviceLaborTotalCostByType(
                                                      "zmcdbLaborCost"
                                                    )
                                                  },
                                                  input: function ($event) {
                                                    return _vm.validateNumber(
                                                      $event,
                                                      "zmcdbLaborCost"
                                                    )
                                                  },
                                                },
                                                model: {
                                                  value:
                                                    _vm.costForm.zmcdbLaborCost,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.costForm,
                                                      "zmcdbLaborCost",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "costForm.zmcdbLaborCost",
                                                },
                                              },
                                              [
                                                _c(
                                                  "template",
                                                  { slot: "prepend" },
                                                  [_vm._v("单个人工成本")]
                                                ),
                                              ],
                                              2
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "el-input",
                                              {
                                                staticStyle: { width: "185px" },
                                                attrs: {
                                                  placeholder: "单价",
                                                  size: "mini",
                                                },
                                                on: {
                                                  blur: function ($event) {
                                                    return _vm.calcDeviceOtherTotalCostByType(
                                                      "zmcdbOtherCost"
                                                    )
                                                  },
                                                  input: function ($event) {
                                                    return _vm.validateNumber(
                                                      $event,
                                                      "zmcdbOtherCost"
                                                    )
                                                  },
                                                },
                                                model: {
                                                  value:
                                                    _vm.costForm.zmcdbOtherCost,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.costForm,
                                                      "zmcdbOtherCost",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "costForm.zmcdbOtherCost",
                                                },
                                              },
                                              [
                                                _c(
                                                  "template",
                                                  { slot: "prepend" },
                                                  [_vm._v("单个其他成本")]
                                                ),
                                              ],
                                              2
                                            ),
                                          ],
                                          1
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.currentShopInfo.lykgczcount > 0 &&
                                  _vm.selectedDeviceType == 5
                                    ? _c("div", { staticClass: "device-row" }, [
                                        _c(
                                          "div",
                                          { staticClass: "device-info" },
                                          [
                                            _vm._v(
                                              "蓝牙开关插座 " +
                                                _vm._s(
                                                  _vm.currentShopInfo
                                                    .lykgczcount
                                                ) +
                                                " 个"
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "device-costs" },
                                          [
                                            _c(
                                              "el-input",
                                              {
                                                staticStyle: { width: "165px" },
                                                attrs: {
                                                  placeholder: "单价",
                                                  size: "mini",
                                                },
                                                on: {
                                                  blur: function ($event) {
                                                    return _vm.calculateDeviceTotalCostByType(
                                                      "lykgczCost"
                                                    )
                                                  },
                                                  input: function ($event) {
                                                    return _vm.validateNumber(
                                                      $event,
                                                      "lykgczCost"
                                                    )
                                                  },
                                                },
                                                model: {
                                                  value:
                                                    _vm.costForm.lykgczCost,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.costForm,
                                                      "lykgczCost",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "costForm.lykgczCost",
                                                },
                                              },
                                              [
                                                _c(
                                                  "template",
                                                  { slot: "prepend" },
                                                  [_vm._v("单个设备成本")]
                                                ),
                                              ],
                                              2
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "el-input",
                                              {
                                                staticStyle: { width: "185px" },
                                                attrs: {
                                                  placeholder: "单价",
                                                  size: "mini",
                                                },
                                                on: {
                                                  blur: function ($event) {
                                                    return _vm.calcDeviceInstallationTotalCostByType(
                                                      "lykgczInstallCost"
                                                    )
                                                  },
                                                  input: function ($event) {
                                                    return _vm.validateNumber(
                                                      $event,
                                                      "lykgczInstallCost"
                                                    )
                                                  },
                                                },
                                                model: {
                                                  value:
                                                    _vm.costForm
                                                      .lykgczInstallCost,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.costForm,
                                                      "lykgczInstallCost",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "costForm.lykgczInstallCost",
                                                },
                                              },
                                              [
                                                _c(
                                                  "template",
                                                  { slot: "prepend" },
                                                  [_vm._v("单个安装费用")]
                                                ),
                                              ],
                                              2
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "el-input",
                                              {
                                                staticStyle: { width: "185px" },
                                                attrs: {
                                                  placeholder: "单价",
                                                  size: "mini",
                                                },
                                                on: {
                                                  blur: function ($event) {
                                                    return _vm.calcDeviceLaborTotalCostByType(
                                                      "lykgczLaborCost"
                                                    )
                                                  },
                                                  input: function ($event) {
                                                    return _vm.validateNumber(
                                                      $event,
                                                      "lykgczLaborCost"
                                                    )
                                                  },
                                                },
                                                model: {
                                                  value:
                                                    _vm.costForm
                                                      .lykgczLaborCost,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.costForm,
                                                      "lykgczLaborCost",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "costForm.lykgczLaborCost",
                                                },
                                              },
                                              [
                                                _c(
                                                  "template",
                                                  { slot: "prepend" },
                                                  [_vm._v("单个人工成本")]
                                                ),
                                              ],
                                              2
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "el-input",
                                              {
                                                staticStyle: { width: "185px" },
                                                attrs: {
                                                  placeholder: "单价",
                                                  size: "mini",
                                                },
                                                on: {
                                                  blur: function ($event) {
                                                    return _vm.calcDeviceOtherTotalCostByType(
                                                      "lykgczOtherCost"
                                                    )
                                                  },
                                                  input: function ($event) {
                                                    return _vm.validateNumber(
                                                      $event,
                                                      "lykgczOtherCost"
                                                    )
                                                  },
                                                },
                                                model: {
                                                  value:
                                                    _vm.costForm
                                                      .lykgczOtherCost,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.costForm,
                                                      "lykgczOtherCost",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "costForm.lykgczOtherCost",
                                                },
                                              },
                                              [
                                                _c(
                                                  "template",
                                                  { slot: "prepend" },
                                                  [_vm._v("单个其他成本")]
                                                ),
                                              ],
                                              2
                                            ),
                                          ],
                                          1
                                        ),
                                      ])
                                    : _vm._e(),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "el-alert el-alert--warning is-light",
                                    staticStyle: {
                                      "margin-top": "10px",
                                      "margin-bottom": "10px",
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "el-alert__content" },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "el-alert__description",
                                            staticStyle: {
                                              "font-size": "14px",
                                              color: "#E6A23C",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "温馨提示：重新成本单价进行计算前请手动清除下方设备成本。"
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            : [
                                _vm.currentShopInfo.cdbcount > 0
                                  ? _c("div", { staticClass: "mr-3" }, [
                                      _c("div", [
                                        _vm._v(
                                          "4G充电宝 " +
                                            _vm._s(
                                              _vm.currentShopInfo.cdbcount
                                            ) +
                                            " 台 "
                                        ),
                                      ]),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.currentShopInfo.cdxcount > 0
                                  ? _c("div", { staticClass: "mr-3" }, [
                                      _c("div", [
                                        _vm._v(
                                          "充电线 " +
                                            _vm._s(
                                              _vm.currentShopInfo.cdxcount
                                            ) +
                                            " 条 "
                                        ),
                                      ]),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.currentShopInfo.cdz10count > 0
                                  ? _c("div", { staticClass: "mr-3" }, [
                                      _c("div", [
                                        _vm._v(
                                          "10路桩 " +
                                            _vm._s(
                                              _vm.currentShopInfo.cdz10count
                                            ) +
                                            " 台 "
                                        ),
                                      ]),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.currentShopInfo.cdz16count > 0
                                  ? _c("div", { staticClass: "mr-3" }, [
                                      _c("div", [
                                        _vm._v(
                                          "16路桩 " +
                                            _vm._s(
                                              _vm.currentShopInfo.cdz16count
                                            ) +
                                            " 台 "
                                        ),
                                      ]),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.currentShopInfo.cdz2count > 0
                                  ? _c("div", { staticClass: "mr-3" }, [
                                      _c("div", [
                                        _vm._v(
                                          "2路4G " +
                                            _vm._s(
                                              _vm.currentShopInfo.cdz2count
                                            ) +
                                            " 个 "
                                        ),
                                      ]),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.currentShopInfo.cdz2lycount > 0
                                  ? _c("div", { staticClass: "mr-3" }, [
                                      _c("div", [
                                        _vm._v(
                                          "2路蓝牙 " +
                                            _vm._s(
                                              _vm.currentShopInfo.cdz2lycount
                                            ) +
                                            " 个 "
                                        ),
                                      ]),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.currentShopInfo.cdz2hpcount > 0
                                  ? _c("div", { staticClass: "mr-3" }, [
                                      _c("div", [
                                        _vm._v(
                                          "2路大功率 " +
                                            _vm._s(
                                              _vm.currentShopInfo.cdz2hpcount
                                            ) +
                                            " 个 "
                                        ),
                                      ]),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.currentShopInfo.zmcdbcount > 0
                                  ? _c("div", { staticClass: "mr-3" }, [
                                      _c("div", [
                                        _vm._v(
                                          "桌面充电宝 " +
                                            _vm._s(
                                              _vm.currentShopInfo.zmcdbcount
                                            ) +
                                            " 个 "
                                        ),
                                      ]),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.currentShopInfo.lykgczcount > 0
                                  ? _c("div", { staticClass: "mr-3" }, [
                                      _c("div", [
                                        _vm._v(
                                          "蓝牙开关插座 " +
                                            _vm._s(
                                              _vm.currentShopInfo.lykgczcount
                                            ) +
                                            " 个 "
                                        ),
                                      ]),
                                    ])
                                  : _vm._e(),
                              ],
                          _vm._v(" "),
                          !_vm.currentShopInfo.cdbcount &&
                          !_vm.currentShopInfo.cdxcount &&
                          !_vm.currentShopInfo.cdz10count &&
                          !_vm.currentShopInfo.cdz2count &&
                          !_vm.currentShopInfo.cdz2lycount &&
                          !_vm.currentShopInfo.cdz2hpcount &&
                          !_vm.currentShopInfo.zmcdbcount &&
                          !_vm.currentShopInfo.lykgczcount
                            ? _c("span", { staticClass: "text-gray" }, [
                                _vm._v("暂无设备"),
                              ])
                            : _vm._e(),
                        ],
                        2
                      ),
                    ]),
                    _vm._v(" "),
                    _c("hr"),
                    _vm._v(" "),
                    _vm.selectedDeviceType != 0
                      ? _c("div", [
                          _c("div", [
                            _c("strong", [_vm._v("   各方投入占比")]),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "flex align-items-center mt-2" },
                            [
                              _c(
                                "div",
                                { staticClass: "flex-wrap" },
                                [
                                  [
                                    _c("div", { staticClass: "device-row" }, [
                                      _c(
                                        "div",
                                        { staticClass: "device-costs" },
                                        [
                                          _c(
                                            "el-input",
                                            {
                                              staticStyle: { width: "180px" },
                                              attrs: {
                                                placeholder:
                                                  "请输入0-100之间的数值",
                                                size: "mini",
                                              },
                                              on: {
                                                input: function ($event) {
                                                  return _vm.validateInvestmentRatio(
                                                    $event,
                                                    "manage"
                                                  )
                                                },
                                              },
                                              model: {
                                                value:
                                                  _vm.investmentRatio.manage,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.investmentRatio,
                                                    "manage",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "investmentRatio.manage",
                                              },
                                            },
                                            [
                                              _c(
                                                "template",
                                                { slot: "prepend" },
                                                [_vm._v("总后台")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "template",
                                                { slot: "append" },
                                                [_vm._v("%")]
                                              ),
                                            ],
                                            2
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "el-input",
                                            {
                                              staticStyle: { width: "200px" },
                                              attrs: {
                                                placeholder:
                                                  "请输入0-100之间的数值",
                                                size: "mini",
                                              },
                                              on: {
                                                input: function ($event) {
                                                  return _vm.validateInvestmentRatio(
                                                    $event,
                                                    "partner"
                                                  )
                                                },
                                              },
                                              model: {
                                                value:
                                                  _vm.investmentRatio.partner,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.investmentRatio,
                                                    "partner",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "investmentRatio.partner",
                                              },
                                            },
                                            [
                                              _c(
                                                "template",
                                                { slot: "prepend" },
                                                [_vm._v("城市合伙人")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "template",
                                                { slot: "append" },
                                                [_vm._v("%")]
                                              ),
                                            ],
                                            2
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "el-input",
                                            {
                                              staticStyle: { width: "180px" },
                                              attrs: {
                                                placeholder:
                                                  "请输入0-100之间的数值",
                                                size: "mini",
                                              },
                                              on: {
                                                input: function ($event) {
                                                  return _vm.validateInvestmentRatio(
                                                    $event,
                                                    "proxy"
                                                  )
                                                },
                                              },
                                              model: {
                                                value:
                                                  _vm.investmentRatio.proxy,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.investmentRatio,
                                                    "proxy",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "investmentRatio.proxy",
                                              },
                                            },
                                            [
                                              _c(
                                                "template",
                                                { slot: "prepend" },
                                                [_vm._v("代理商")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "template",
                                                { slot: "append" },
                                                [_vm._v("%")]
                                              ),
                                            ],
                                            2
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "el-input",
                                            {
                                              staticStyle: { width: "180px" },
                                              attrs: {
                                                placeholder:
                                                  "请输入0-100之间的数值",
                                                size: "mini",
                                              },
                                              on: {
                                                input: function ($event) {
                                                  return _vm.validateInvestmentRatio(
                                                    $event,
                                                    "salesperson"
                                                  )
                                                },
                                              },
                                              model: {
                                                value:
                                                  _vm.investmentRatio
                                                    .salesperson,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.investmentRatio,
                                                    "salesperson",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "investmentRatio.salesperson",
                                              },
                                            },
                                            [
                                              _c(
                                                "template",
                                                { slot: "prepend" },
                                                [_vm._v("业务员")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "template",
                                                { slot: "append" },
                                                [_vm._v("%")]
                                              ),
                                            ],
                                            2
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "el-input",
                                            {
                                              staticStyle: { width: "180px" },
                                              attrs: {
                                                placeholder:
                                                  "请输入0-100之间的数值",
                                                size: "mini",
                                              },
                                              on: {
                                                input: function ($event) {
                                                  return _vm.validateInvestmentRatio(
                                                    $event,
                                                    "promoter"
                                                  )
                                                },
                                              },
                                              model: {
                                                value:
                                                  _vm.investmentRatio.promoter,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.investmentRatio,
                                                    "promoter",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "investmentRatio.promoter",
                                              },
                                            },
                                            [
                                              _c(
                                                "template",
                                                { slot: "prepend" },
                                                [_vm._v("推广员")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "template",
                                                { slot: "append" },
                                                [_vm._v("%")]
                                              ),
                                            ],
                                            2
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "el-input",
                                            {
                                              staticStyle: { width: "180px" },
                                              attrs: {
                                                placeholder:
                                                  "请输入0-100之间的数值",
                                                size: "mini",
                                              },
                                              on: {
                                                input: function ($event) {
                                                  return _vm.validateInvestmentRatio(
                                                    $event,
                                                    "merchants"
                                                  )
                                                },
                                              },
                                              model: {
                                                value:
                                                  _vm.investmentRatio.merchants,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.investmentRatio,
                                                    "merchants",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "investmentRatio.merchants",
                                              },
                                            },
                                            [
                                              _c(
                                                "template",
                                                { slot: "prepend" },
                                                [_vm._v("商家")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "template",
                                                { slot: "append" },
                                                [_vm._v("%")]
                                              ),
                                            ],
                                            2
                                          ),
                                        ],
                                        1
                                      ),
                                    ]),
                                  ],
                                ],
                                2
                              ),
                            ]
                          ),
                        ])
                      : _vm._e(),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticStyle: { height: "20px" } }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "cost-section card-shadow card-elevation",
                    staticStyle: {
                      "background-color": "#FAFAFC",
                      padding: "8px",
                      "border-radius": "12px",
                    },
                  },
                  [
                    _c("h3", [_vm._v("固定成本(元)")]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "cost-form" },
                      [
                        _c(
                          "el-form",
                          {
                            attrs: {
                              model: _vm.costForm,
                              "label-width": "90px",
                            },
                          },
                          [
                            _c(
                              "el-row",
                              { attrs: { gutter: 29 } },
                              [
                                _c(
                                  "el-col",
                                  { attrs: { span: 5 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      { attrs: { label: "设备成本" } },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            disabled:
                                              _vm.selectedDeviceType === "0",
                                            placeholder: "请输入设备成本",
                                          },
                                          model: {
                                            value: _vm.costForm.deviceCost,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.costForm,
                                                "deviceCost",
                                                $$v
                                              )
                                            },
                                            expression: "costForm.deviceCost",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-col",
                                  { attrs: { span: 5 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      { attrs: { label: "安装费用" } },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            disabled:
                                              _vm.selectedDeviceType === "0",
                                            placeholder: "请输入安装费用",
                                          },
                                          model: {
                                            value:
                                              _vm.costForm.installationCost,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.costForm,
                                                "installationCost",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "costForm.installationCost",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-col",
                                  { attrs: { span: 5 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      { attrs: { label: "人工成本" } },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            disabled:
                                              _vm.selectedDeviceType === "0",
                                            placeholder: "请输入人工成本",
                                          },
                                          model: {
                                            value: _vm.costForm.laborCost,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.costForm,
                                                "laborCost",
                                                $$v
                                              )
                                            },
                                            expression: "costForm.laborCost",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-col",
                                  { attrs: { span: 5 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      { attrs: { label: "其他成本" } },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            disabled:
                                              _vm.selectedDeviceType === "0",
                                            placeholder: "请输入其他成本",
                                          },
                                          model: {
                                            value: _vm.costForm.otherCost,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.costForm,
                                                "otherCost",
                                                $$v
                                              )
                                            },
                                            expression: "costForm.otherCost",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-col",
                                  { attrs: { span: 1 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      [
                                        _vm.selectedDeviceType !== "0"
                                          ? _c(
                                              "el-button",
                                              {
                                                attrs: { type: "primary" },
                                                on: {
                                                  click:
                                                    _vm.saveCalculateTotalCost,
                                                },
                                              },
                                              [_vm._v("保存")]
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "备注" } },
                              [
                                _c("el-input", {
                                  attrs: {
                                    disabled: _vm.selectedDeviceType === "0",
                                    placeholder: "请输入备注信息",
                                  },
                                  model: {
                                    value: _vm.costForm.remark,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.costForm, "remark", $$v)
                                    },
                                    expression: "costForm.remark",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "总成本" } },
                              [
                                _c("el-input", {
                                  attrs: {
                                    value: _vm.costForm.totalCost,
                                    disabled: "",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticStyle: { height: "20px" } }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "break-even-section card-shadow card-elevation",
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "countdown",
                        staticStyle: {
                          "background-color": "#FAFAFC",
                          padding: "8px",
                          "border-radius": "12px",
                          "border-left": "6px solid #5047D8",
                        },
                      },
                      [
                        _c("h3", [_vm._v("回本倒计时")]),
                        _vm._v(" "),
                        _c(
                          "el-row",
                          { attrs: { gutter: 20 } },
                          [
                            _c("el-col", { attrs: { span: 12 } }, [
                              _c("div", { staticClass: "days" }, [
                                _c("span", [_vm._v("预计剩余回本天数")]),
                                _vm._v(" "),
                                _c(
                                  "h2",
                                  { staticStyle: { color: "#5047D8" } },
                                  [_vm._v(_vm._s(_vm.breakEvenDays))]
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("el-col", { attrs: { span: 12 } }, [
                              _c(
                                "div",
                                { staticClass: "progress" },
                                [
                                  _c("el-progress", {
                                    attrs: {
                                      percentage: _vm.breakEvenPercentage,
                                      "show-text": false,
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.breakEvenPercentage) + "%"
                                    ),
                                  ]),
                                ],
                                1
                              ),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticStyle: { height: "20px" } }),
                    _vm._v(" "),
                    _c("div", [
                      _c("div", [_c("strong", [_vm._v("   回本分布情况")])]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "flex align-items-center mt-2" },
                        [
                          _c(
                            "div",
                            { staticClass: "flex-wrap" },
                            [
                              [
                                _c("div", { staticClass: "device-row" }, [
                                  _c(
                                    "div",
                                    { staticClass: "device-costs" },
                                    [
                                      _c(
                                        "el-input",
                                        {
                                          staticStyle: { width: "180px" },
                                          attrs: { size: "mini", disabled: "" },
                                          model: {
                                            value: _vm.recoveryRatio.manage,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.recoveryRatio,
                                                "manage",
                                                $$v
                                              )
                                            },
                                            expression: "recoveryRatio.manage",
                                          },
                                        },
                                        [
                                          _c("template", { slot: "prepend" }, [
                                            _vm._v("总后台"),
                                          ]),
                                          _vm._v(" "),
                                          _c("template", { slot: "append" }, [
                                            _vm._v("元"),
                                          ]),
                                        ],
                                        2
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-input",
                                        {
                                          staticStyle: { width: "200px" },
                                          attrs: { size: "mini", disabled: "" },
                                          model: {
                                            value: _vm.recoveryRatio.partner,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.recoveryRatio,
                                                "partner",
                                                $$v
                                              )
                                            },
                                            expression: "recoveryRatio.partner",
                                          },
                                        },
                                        [
                                          _c("template", { slot: "prepend" }, [
                                            _vm._v("城市合伙人"),
                                          ]),
                                          _vm._v(" "),
                                          _c("template", { slot: "append" }, [
                                            _vm._v("元"),
                                          ]),
                                        ],
                                        2
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-input",
                                        {
                                          staticStyle: { width: "180px" },
                                          attrs: { size: "mini", disabled: "" },
                                          model: {
                                            value: _vm.recoveryRatio.proxy,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.recoveryRatio,
                                                "proxy",
                                                $$v
                                              )
                                            },
                                            expression: "recoveryRatio.proxy",
                                          },
                                        },
                                        [
                                          _c("template", { slot: "prepend" }, [
                                            _vm._v("代理商"),
                                          ]),
                                          _vm._v(" "),
                                          _c("template", { slot: "append" }, [
                                            _vm._v("元"),
                                          ]),
                                        ],
                                        2
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-input",
                                        {
                                          staticStyle: { width: "180px" },
                                          attrs: { size: "mini", disabled: "" },
                                          model: {
                                            value:
                                              _vm.recoveryRatio.salesperson,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.recoveryRatio,
                                                "salesperson",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "recoveryRatio.salesperson",
                                          },
                                        },
                                        [
                                          _c("template", { slot: "prepend" }, [
                                            _vm._v("业务员"),
                                          ]),
                                          _vm._v(" "),
                                          _c("template", { slot: "append" }, [
                                            _vm._v("元"),
                                          ]),
                                        ],
                                        2
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-input",
                                        {
                                          staticStyle: { width: "180px" },
                                          attrs: { size: "mini", disabled: "" },
                                          model: {
                                            value: _vm.recoveryRatio.promoter,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.recoveryRatio,
                                                "promoter",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "recoveryRatio.promoter",
                                          },
                                        },
                                        [
                                          _c("template", { slot: "prepend" }, [
                                            _vm._v("推广员"),
                                          ]),
                                          _vm._v(" "),
                                          _c("template", { slot: "append" }, [
                                            _vm._v("元"),
                                          ]),
                                        ],
                                        2
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-input",
                                        {
                                          staticStyle: { width: "220px" },
                                          attrs: { size: "mini", disabled: "" },
                                          model: {
                                            value: _vm.recoveryRatio.merchants,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.recoveryRatio,
                                                "merchants",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "recoveryRatio.merchants",
                                          },
                                        },
                                        [
                                          _c("template", { slot: "prepend" }, [
                                            _vm._v("商家"),
                                          ]),
                                          _vm._v(" "),
                                          _c("template", { slot: "append" }, [
                                            _vm._v("元"),
                                          ]),
                                        ],
                                        2
                                      ),
                                    ],
                                    1
                                  ),
                                ]),
                              ],
                            ],
                            2
                          ),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticStyle: { height: "20px" } }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "stats" },
                      [
                        _c(
                          "el-row",
                          { attrs: { gutter: 24 } },
                          [
                            _c("el-col", { attrs: { span: 5 } }, [
                              _c(
                                "div",
                                {
                                  staticClass: "stat-item",
                                  staticStyle: {
                                    "background-color": "#FAFAFC",
                                    padding: "8px",
                                    "border-radius": "12px",
                                  },
                                },
                                [
                                  _c("span", [_vm._v("平均日收入")]),
                                  _vm._v(" "),
                                  _c("h4", [
                                    _vm._v(_vm._s(_vm.averageDailyIncome)),
                                  ]),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _c("el-col", { attrs: { span: 5 } }, [
                              _c(
                                "div",
                                {
                                  staticClass: "stat-item",
                                  staticStyle: {
                                    "background-color": "#FAFAFC",
                                    padding: "8px",
                                    "border-radius": "12px",
                                  },
                                },
                                [
                                  _c("span", [_vm._v("平均月收入")]),
                                  _vm._v(" "),
                                  _c("h4", [
                                    _vm._v(_vm._s(_vm.averageChangeMoneyMonth)),
                                  ]),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _c("el-col", { attrs: { span: 4 } }, [
                              _c(
                                "div",
                                {
                                  staticClass: "stat-item",
                                  staticStyle: {
                                    "background-color": "#FAFAFC",
                                    padding: "8px",
                                    "border-radius": "12px",
                                  },
                                },
                                [
                                  _c("span", [_vm._v("已营运天数")]),
                                  _vm._v(" "),
                                  _c("h4", [
                                    _vm._v(_vm._s(_vm.daysSinceOperation)),
                                  ]),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _c("el-col", { attrs: { span: 5 } }, [
                              _c(
                                "div",
                                {
                                  staticClass: "stat-item",
                                  staticStyle: {
                                    "background-color": "#FAFAFC",
                                    padding: "8px",
                                    "border-radius": "12px",
                                  },
                                },
                                [
                                  _c("span", [_vm._v("已收回成本")]),
                                  _vm._v(" "),
                                  _c("h4", [_vm._v(_vm._s(_vm.recoveredCost))]),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _c("el-col", { attrs: { span: 5 } }, [
                              _c(
                                "div",
                                {
                                  staticClass: "stat-item",
                                  staticStyle: {
                                    "background-color": "#FAFAFC",
                                    padding: "8px",
                                    "border-radius": "12px",
                                  },
                                },
                                [
                                  _c("span", [_vm._v("剩余成本")]),
                                  _vm._v(" "),
                                  _c("h4", [_vm._v(_vm._s(_vm.remainingCost))]),
                                ]
                              ),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _c("editwith", { ref: "editwith", attrs: { type: 1 } }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }